import { deserialize, serialize } from "class-transformer";
import { DeliveryAddress } from "../../shared/models/form/delivery-address.model";
import { DeliveryMethod } from "../../shared/models/form/delivery-method.model";
import { Control, Param } from "./Control";
import { KrokStep } from "./StepKrok";
import { Parameter } from "src/app/shared/models/form-model/models/form-controlls.model";
import { Order } from "./Order";
import { Modul } from "./Modul";
import { GrupaKrokow } from "./GrupaKrokow";
import { TypEnum } from "./TypEnum";
import { FormV2ServiceService } from "../form-v2-service.service";
import { Delivery } from "./Delivery";
import { Supervisor } from "./Supervisor";
import * as _ from 'lodash';
import { FormDataSend } from "./FormDataSend";
import { KindOper } from '../../shared/enums/kind-oper-enum';
import { Parametr } from "src/app/pomocnicze/parametry_wybrane";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { UniversalDialogComponent } from "src/app/shared/components/universal-dialog/universal-dialog.component";
import { DialogData } from "src/app/shared/models/dialog/dialog-data.model";
import { Kim } from "src/app/shared/models/form-model/kim.model";
import { FormService } from "src/app/shared/service/form.service";
import { FileControl } from "src/app/shared/models/form/file-control.model";
import { FormDataV2Save } from "./FormDataV2Save";
import { KimSave } from "./KimSave";
import * as htmlToImage from 'html-to-image';
import { Contractor } from "src/app/shared/models/user/contractor.model";
import { Technologia } from "src/app/shared/technologia/technologia";
import { Inspector } from "src/app/inspector-viewer/Models/inspektor";
import { TresciService } from "src/app/tresci.service";

export class FormDataV2 {

    //kroki:KrokStep[] = [];

    zapisuje:boolean = false;

    Order:Order;
    OrderSave:Order;
    supervisor:Supervisor = new Supervisor();

    Parameters:Parameter[] = [];
    Files:FileControl[] = [];
    public ParameterExtensions:Kim[] = [];
    
    delivery:Delivery = new Delivery();

    produktPrefix: string;
    orderId: any;
    kindOper: any;

    public inspector:Inspector;

    public naglowek:GrupaKrokow;
    public moduly:Modul[] = [];
    public stopka:GrupaKrokow;
    public CzyWczytane = false;
    culture: string;
    IsTrader: boolean;
    wczytywanie: boolean;

    parent_Parameters:Parameter[] = [];
    id_parent:number = null;

    TechVersion: Number;
    ValuationVersion: Number;
    IsFooter: boolean;
    IsModule: boolean;
    IsModuleFooter: boolean;

    IloscWczytana: Number = 0;
    ModuleCount: Number = 1;

    LoadingName:string = 'naglowek'; //'zestaw_lad';
    ostatniKrok: KrokStep;
  Preview: boolean;
    fileUrl: any;

    
  public krokiTMP:KrokStep[] = [];
  public numer_krokuTMP = 0;
  public pozycjaTMP = 0;
  public modulTMP = 0;
    duplikat: boolean = false;
    byl_duplikat: boolean = false;
  Valuation: boolean = false;
    Contractor: Contractor;
    wczytajPotem: boolean = false;
    wczytywanie_block: boolean;
    start: number;
    czas_wyk: string[] = [];
    licz_trw: number =1;
  typ_test: any;
    isCache: boolean = true;
    
    constructor(private router: Router, private formService: FormV2ServiceService, public useParts){
        this.naglowek = new GrupaKrokow(TypEnum.Header);
        this.stopka = new GrupaKrokow(TypEnum.Footer);
        this.Contractor = JSON.parse(sessionStorage.getItem('_slc')) as Contractor;
    }

    
    /*
    public MaxMod(){
        var mod = 0;
        this.Parameters.forEach(param => {
            if(param.Module > mod){
                mod = param.Module;
            }
        });
        return mod;
    }

    public MaxPoz(){
        var poz = 0;
        this.Parameters.forEach(param => {
            if(param.Position > poz){
                poz = param.Position;
            }
        });
        return poz;
    }
    public CzyBylaStopkaMod(mod){
        var stop = false;
        this.Parameters.forEach(param => {
            if(param.Type == TypEnum.ModuleFooter && param.Module == mod){
                stop = true;
            }
        });
        return stop;
    }
    public CzyBylFooter(){
        var stop = false;
        this.Parameters.forEach(param => {
            if(param.Type == TypEnum.Footer){
                stop = true;
            }
        });
        return stop;
    }
    */
/*
    GetNg(numer_modul:number){
        var naglowki:String[] = [];
        


        this.moduly[numer_modul].pozycje.forEach(poz => {
            poz.kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            if(con.ControlType != "Hidden"){
                                // con.wybrany;
                                var jest = naglowki.find(x => x == con.wybrany.Key);
                                                            
                                if(jest == null){
                                        naglowki.push(con.wybrany.Key);
                                }
                            }
                        }
                    });
                
            });
        });

        return naglowki;
    } */
public wczytajParentParam(formService:FormV2ServiceService){
    formService.getOrderParameters(this.orderId).
    subscribe((data) => {
      this.parent_Parameters = data.Parameters;
    });
}
    public nextModule(){
        this.supervisor.aktualny_mod++;
    }
    ustawModuly() {
        var pos = 0;
        var mod = 0;
        // console.log("params", this.Parameters);
        this.Parameters.forEach(param => {
            while(this.moduly.length < param.Module){
                this.moduly.push(new Modul());
            }
            // console.log(param.Module, param.Position, this.moduly.length);
            while(param.Module > 0  && this.moduly[param.Module - 1].pozycje.length < param.Position){
                this.moduly[param.Module - 1].pozycje.push(new GrupaKrokow(TypEnum.Position));
            }
            
        });
    }
    public poprawParametryDodane(modul:number, position:number){
        // console.log("przed", this.Parameters);
        
        this.Parameters.forEach(element => {
            if(element.Module == modul + 1 && element.Position >= position){
                element.Position++; 
            }
        });
        this.AktualizujPlikiPergola(modul + 1, position);
      /*  this.Files.forEach(file => {
            if(file.Module == modul + 1 && file.Position >= position){
                file.Position++;
                if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                    file.FileName = "Pergola "+(modul + 1) + "_" + (position + 1) + ".png";
                }
            } 
        });*/
        // console.log("po", this.Parameters);
    }
    public DodajPozycje(tresci, formService:FormV2ServiceService, czyscroll = true, modul:number, dialog: MatDialog){
        this.supervisor.aktualna_poz = this.moduly[modul].pozycje.length + 1;
        if(this.moduly[modul].moduleNg.GetLastStep() == undefined){
            this.wczytajKrok(formService, true, tresci, this.naglowek.GetLastStep().Step, dialog, this.naglowek.GetLastStep().Number, 0); 
        } else {
            this.wczytajKrok(formService, true, tresci, this.moduly[modul].moduleNg.GetLastStep().Step, dialog, this.moduly[modul].moduleNg.GetLastStep().Number, 0); 
        }
        
    }
    public DodajPozycjeAuto(modul:number, position:number){
        //this.supervisor.aktualna_poz = this.moduly[modul].pozycje.length + 1;
        //this.moduly[modul].pozycje.push(new GrupaKrokow(TypEnum.Position));
        // console.log("pozycja auto");
        this.moduly[modul].pozycje.splice(position - 1, 0, new GrupaKrokow(TypEnum.Position));
        this.poprawParametryDodane(modul, position);
        this.poprawNumeryPoz();
        this.stopka.WyczyscWszystko();
        
    }
    public DodajPozycjeAutoBez(modul:number){
        //this.supervisor.aktualna_poz = this.moduly[modul].pozycje.length + 1;
        this.moduly[modul].pozycje.push(new GrupaKrokow(TypEnum.Position));
        // this.moduly[modul].pozycje.splice(position - 1, 0, new GrupaKrokow(TypEnum.Position));
        // this.poprawParametryDodane(modul, position);
        this.poprawNumeryPoz();
        this.stopka.WyczyscWszystko();
        
    }
    public UsunPozycje(tresci, formService:FormV2ServiceService, czyscroll = true, modul:number, p:number, dialog: MatDialog){
        if(p < this.moduly[modul].pozycje.length){
            this.usunDalszePoz(p);
        }
        this.moduly[modul].pozycje.splice(p, 1);
        
        if(this.moduly[modul].pozycje.length == 0){
            this.DodajPozycje(tresci, formService, czyscroll, modul, dialog);
        }
        this.Parameters.forEach(param => {
            if(param.Module == modul + 1 && param.Position == p + 1){
                param.Position = 9999999;
            } else if(param.Module == modul + 1 && param.Position > p + 1){
                param.Position--;
            }
        });
        this.poprawNumeryPoz();
        this.stopka.WyczyscWszystko();
        // console.log("usuwam stopke 1");
    }
    
    public UsunPozycjeAuto(tresci, formService:FormV2ServiceService, czyscroll = true, modul:number, p:number, dialog: MatDialog){
        if(p < this.moduly[modul].pozycje.length){
            this.usunDalszePoz(p);
        }
        this.moduly[modul].pozycje.splice(p, 1);
        
        if(this.moduly[modul].pozycje.length == 0){
            // this.DodajPozycje(tresci, formService, czyscroll, modul, dialog);
        }
        this.Parameters.forEach(param => {
            if(param.Module == modul + 1 && param.Position == p + 1){
                param.Position = 9999999;
            } else if(param.Module == modul + 1 && param.Position > p + 1){
                param.Position--;
            }
        });
        
        this.Files.forEach(file => {
            if(file.Module == modul + 1 && file.Position == p + 1){
                file.Position = 9999999;
                if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                    file.FileName = "Pergola 999999999";
                }
            } else if(file.Module == modul + 1 && file.Position > p + 1){
                if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                    file.FileName = "Pergola " + file.Module + "_" + (file.Position-1)+".png";
                }
                file.Position--;
            }
        });
        this.poprawNumeryPoz();
        this.stopka.WyczyscWszystko();
        // console.log("usuwam stopke 1");
    }
    public EdytujPozycje(tresci, formService:FormV2ServiceService, czyscroll = true, modul:number, p:number, dialog: MatDialog){
        // console.log("edytyje pozycje", p, modul);
        this.supervisor.EdytujPozycje(p);
        if(this.AktualneKroki().kroki.length == 0){
            if(this.IsModule){
                // console.log("modul", modul, this.moduly);
                this.wczytajKrok(formService, true, tresci, this.moduly[modul].moduleNg.GetLastStep().Step, dialog, this.moduly[modul].moduleNg.GetLastStep().Number, 0); 
            } else {
                this.wczytajKrok(formService, true, tresci, this.naglowek.GetLastStep().Step, dialog, this.naglowek.GetLastStep().Number, 0); 
            }
            
        } 
    }
    public WczytajModuleFooter(modul:number, formService:FormV2ServiceService, tresci, dialog: MatDialog){
        // console.log("mod foot",this.moduly[modul].pozycje,  this.moduly[modul].pozycje[this.moduly[modul].pozycje.length - 1].GetLastStep().Step, this.supervisor.aktualna_poz);
        // this.supervisor.aktualna_poz = this.moduly[modul].pozycje.length - 1;
        this.wczytajKrok(formService, true, tresci, this.moduly[modul].pozycje[this.moduly[modul].pozycje.length - 1].GetLastStep().Step, dialog, this.moduly[modul].pozycje[this.moduly[modul].pozycje.length - 1].GetLastStep().Number, 0); 
    }
    public WczytajFooter(modul:number, formService:FormV2ServiceService, tresci, dialog: MatDialog){
        if(this.IsModuleFooter){
            this.wczytajKrok(formService, true, tresci, this.moduly[modul].moduleFooter.GetLastStep().Step, dialog, this.moduly[modul].moduleFooter.GetLastStep().Number, 0); 
        } else {
            this.wczytajKrok(formService, true, tresci, this.moduly[modul].pozycje[this.moduly[modul].pozycje.length - 1].GetLastStep().Step, dialog, this.moduly[modul].pozycje[this.moduly[modul].pozycje.length - 1].GetLastStep().Number, 0); 
        }
        
    }

    public moveToModuleFooter(modul:number, formService:FormV2ServiceService, tresci, dialog: MatDialog){
        this.moduly[modul].zakonczono_pozycje = true;
        // console.log(this.moduly[modul].moduleFooter, this.moduly[modul].moduleFooter.CzyZakonczony(), this.IsModuleFooter);
        if(this.moduly[modul].moduleFooter.kroki.length == 0 && this.IsModuleFooter){
            
            this.supervisor.aktualnyTyp = TypEnum.ModuleFooter;
            this.supervisor.aktualna_poz = 0;
            this.WczytajModuleFooter(modul, formService, tresci, dialog);
        } else {

            if(!this.IsModuleFooter){
                this.moduly[modul].moduleFooter.poprawnie_zakonczone = true;
                this.moduly[modul].moduleFooter.edytowane = false;
            } else {
                this.supervisor.aktualnyTyp = TypEnum.ModuleFooter
            }

            if(this.supervisor.auto.valueOf() > 0){
                this.nextAutoEnd(tresci, formService, true, dialog, null);
            } else {
                
                if(this.moduly[modul].moduleFooter.CzyZakonczony()){
                    if(this.IsFooter){
                        this.supervisor.aktualnyTyp = TypEnum.Footer;
                    /* 
                        this.supervisor.aktualna_poz = 0; 
                        this.supervisor.aktualny_mod = 0;
                        if(this.stopka == null || this.stopka.kroki.length == 0){
                            this.WczytajFooter(modul, formService, tresci, dialog);
                        } else {
                            this.supervisor.zakladka = 2;
                        }*/
                        
                    } else {
                            
                        this.stopka.poprawnie_zakonczone = true;
                        this.stopka.edytowane = false;
                    }
                } else {
                    
                }
                //this.moduly[modul].moduleFooter.poprawnie_zakonczone = true;
                //this.moduly[modul].moduleFooter.edytowane = false;
            }
            
            
            
        }
    }

    public WrocDoEdycjiPoz(modul:number){
        this.moduly[modul].zakonczono_pozycje = false;
        this.supervisor.aktualnyTyp = TypEnum.Position;
        // console.log("bez auto wroc do pozycji");
        this.supervisor.auto = 0;
        
    }
    public CzyModulyZakonczone(){
        var zakonczone = true;
        this.moduly.forEach(mod => {
            if(!mod.zakonczono_pozycje){
                zakonczone = false;
            }
            if(!mod.moduleFooter.CzyZakonczony()){
                zakonczone = false;
            }
        });
        if(this.moduly.length == 0){
            zakonczone = false;
        }
        
        return zakonczone;
    }
    public updateParameterExtensions(){
        for(var i = this.ParameterExtensions.length - 1;i >= 0; i--){
            if(this.ParameterExtensions[i].Module == 0){

            } else {
                if(this.ParameterExtensions[i].Module > this.moduly.length){
                    this.ParameterExtensions.splice(i, 1);
                    // console.log("kim za duzy modul...");
                } else if(this.ParameterExtensions[i].Position > this.moduly[this.ParameterExtensions[i].Module - 1].pozycje.length){
                    this.ParameterExtensions.splice(i, 1);
                    // console.log("kim za duza pozycja...");
                } else {
                    var byl_kim = false;
                    this.moduly[this.ParameterExtensions[i].Module - 1].pozycje.forEach(poz => {
                        poz.kroki.forEach(krok => {
                            krok.Controlls.forEach(con => {
                                
                                if(con.ControlType == "Kim"){
                                    byl_kim = true;
                                }
                            });
                        });
                    });
                    if(!byl_kim){
                        // console.log("brak kontrolki kim...", i );
                        this.ParameterExtensions.splice(i, 1);
                        // console.log(this.ParameterExtensions);
                    }
                }
            }
            
        }
        
    }
    public jestDuplikat(formService:FormV2ServiceService, dialog){
        let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
                    const dataDial: DialogData = {
                    title: '',
                    content:  "wykryto problem z danymi, uruchomiono auto-naprawę",
                    answerOk: true,
                    };
                    dialogRef = dialog.open(UniversalDialogComponent, { data: dataDial, role: 'alertdialog' });
                    this.supervisor.zakladka = 0;
                    this.active(this.naglowek, 0, 0, 0, 'Header');
                    this.usunDalsze(null);
                    this.supervisor.skip = false;
                    this.supervisor.byl_skip = true;
                    this.supervisor.auto = 2;
                    this.next(null, formService, 'Header', true, dialog);
                    this.byl_duplikat = true;

    }
    public quickSave(formService:FormV2ServiceService, dialog){
        this.wczytywanie = true;
        this.zapisuje = true;
        //var param = this.GetAllParams();
        // console.log(param);
        var formData:FormDataSend = new FormDataSend();
        formData.Parameters = this.GetAllParams();
        if(this.duplikat){
            this.wczytywanie = false;
            this.zapisuje = false;
            this.jestDuplikat(formService, dialog);
        } else {
            this.updateParameterExtensions();
            formData.ParameterExtensions = this.ParameterExtensions;
            formData.ContractorNumber = JSON.parse(sessionStorage.getItem('_slc')).ContractorNumber;
            
            formData.Culture = this.culture;
            if(this.delivery == null || this.delivery.ChosenAdresses == null || this.delivery.ChosenAdresses.Id == 0){
                formData.DeliveryAddressId = null;
            } else {
                formData.DeliveryAddressId = this.delivery.ChosenAdresses.Id;
                formData.DeliveryAddress = this.delivery.ChosenAdresses.Address;
                formData.DeliveryCity = this.delivery.ChosenAdresses.City;
                formData.DeliveryCountry = this.delivery.ChosenAdresses.Country;
                formData.DeliveryZipCode = this.delivery.ChosenAdresses.ZipCode;
            }
            formData.DeliveryMethod = this.delivery.DeliveryMethod.Name;
            formData.DeliveryMethodId = this.delivery.DeliveryMethod.Name;
            if(this.kindOper === KindOper.Copy){
                formData.CopiedOrderId = this.orderId;
                formData.Id = 0;
            } else {
                formData.CopiedOrderId = null;
                formData.Id = this.orderId;
            }
            formData.IsCache = true;
            
            if(this.delivery.ComplaintType != null){
                if(this.delivery.ComplaintType.Id == 1){
                    formData.IsComplaint = true;
                    formData.ComplaintId = this.delivery.ChosenComplaint.Id;
                    formData.ComplaintNumber = this.delivery.ChosenComplaint.ComplaintNumber;
                    formData.ChargeableRepairsId = null;
                    formData.ChargeableRepairsNumber = null;
                    formData.ComplaintType  = this.delivery.ComplaintType.Id;
                } else {
                    formData.IsComplaint = true;
                    formData.ComplaintId = null;
                    formData.ComplaintNumber = null;
                    formData.ChargeableRepairsId = this.delivery.ChosenComplaint.Id;
                    formData.ChargeableRepairsNumber = this.delivery.ChosenComplaint.ComplaintNumber;
                    formData.ComplaintType  = this.delivery.ComplaintType.Id;
                }
            } else {
                formData.IsComplaint = null;
            }
            



            formData.IsTrader = this.IsTrader;
            formData.ProductPrefix = this.produktPrefix;
            formData.TechnologyVersion = this.TechVersion;
            formData.ParentId = this.id_parent;


            if(this.Valuation){
                formData.Valuation = true;
            }

            formService.AddorUpdateActiveFormOrderWithFiles(formData, this.Files).
            subscribe((data) => {
                this.orderId = data;
                if(this.kindOper != KindOper.EditClient){
                    this.kindOper = KindOper.Edit;
                }
                
                this.wczytywanie = false;
                this.zapisuje = false;
            //localStorage.setItem('goToPage', '');
            //this.router.navigate(['Orders']);
            
            }, (err) => {
                // console.log("blad zapisu");
                this.wczytywanie = false;
                this.zapisuje = false;
            }, () => {
                // console.log("po zapisie");
                this.wczytywanie = false;
                this.zapisuje = false;
            }
            
            );
        }
        
    }
    
    
    public save(formService:FormV2ServiceService, dialog){
        
        this.wczytywanie = true;
        this.zapisuje = true;
        //var param = this.GetAllParams();
        // console.log(param);


        


        
        var formData:FormDataSend = new FormDataSend();
        formData.Parameters = this.GetAllParams();
        if(this.duplikat){
            this.wczytywanie = false;
            this.zapisuje = false;
            this.jestDuplikat(formService, dialog);
        } else {
            this.updateParameterExtensions();
            formData.ParameterExtensions = this.ParameterExtensions;
            formData.ContractorNumber = JSON.parse(sessionStorage.getItem('_slc')).ContractorNumber;
            
            formData.Culture = this.culture;
            // console.log("form2", this);
            formData.DeliveryMethod = this.delivery.DeliveryMethod.Name;
            if(this.delivery == null || this.delivery.ChosenAdresses == null){
                formData.DeliveryAddressId = null;
            } else {
                formData.DeliveryAddressId = this.delivery.ChosenAdresses.Id;
                formData.DeliveryAddress = this.delivery.ChosenAdresses.Address;
                formData.DeliveryCity = this.delivery.ChosenAdresses.City;
                formData.DeliveryCountry = this.delivery.ChosenAdresses.Country;
                formData.DeliveryZipCode = this.delivery.ChosenAdresses.ZipCode;
            }
            
            formData.DeliveryMethodId = this.delivery.DeliveryMethod.Name;
            if(this.kindOper === KindOper.Copy){
                formData.CopiedOrderId = this.orderId;
                formData.Id = 0;
            } else {
                formData.CopiedOrderId = null;
                formData.Id = this.orderId;
            }
            formData.IsCache = true;
            
            if(this.delivery.ComplaintType != null){
                if(this.delivery.ComplaintType.Id == 1){
                    formData.IsComplaint = true;
                    formData.ComplaintId = this.delivery.ChosenComplaint.Id;
                    formData.ComplaintNumber = this.delivery.ChosenComplaint.ComplaintNumber;
                    formData.ChargeableRepairsId = null;
                    formData.ChargeableRepairsNumber = null;
                    formData.ComplaintType  = this.delivery.ComplaintType.Id;
                } else {
                    formData.IsComplaint = true;
                    formData.ComplaintId = null;
                    formData.ComplaintNumber = null;
                    formData.ChargeableRepairsId = this.delivery.ChosenComplaint.Id;
                    formData.ChargeableRepairsNumber = this.delivery.ChosenComplaint.ComplaintNumber;
                    formData.ComplaintType  = this.delivery.ComplaintType.Id;
                }
            } else {
                formData.IsComplaint = null;
            }
    
            formData.IsTrader = this.IsTrader;
            formData.ProductPrefix = this.produktPrefix;
            formData.TechnologyVersion = this.TechVersion;
            formData.ParentId = this.id_parent;
            if(this.Valuation){
                formData.Valuation = true;
            }
            // console.log("form", formData);
            //this.wczytywanie = false;
            //this.zapisuje = false;
            // console.log("zam", formData);
            formService.AddorUpdateActiveFormOrderWithFiles(formData, this.Files).
            subscribe((data) => {
                
              this.wczytywanie = false;
              this.zapisuje = false;
              localStorage.setItem('goToPage', '');
              if(this.Valuation){
                this.router.navigate(['Valuations']);
              } else {
                this.router.navigate(['Orders']);
              }
              
              
            }, (err) => {
                // console.log("blad zapisu");
                this.wczytywanie = false;
                this.zapisuje = false;
            }, () => {
                // console.log("po zapisie");
                this.wczytywanie = false;
                this.zapisuje = false;
            }
            
            );
        }
        
    }

    public ustawDelivery(DeliveryMethodId, ContractorAddressId){
        // console.log("id del", DeliveryMethodId);

       

        this.delivery.DeliveryMethods.forEach(del => { 
            
        // console.log("id del", DeliveryMethodId, del.Name);
            if(del.Name == DeliveryMethodId || del.Id == DeliveryMethodId) {
                this.delivery.DeliveryMethod = del;
            }
        });
        // console.log(this.delivery.ContractorAddresses, ContractorAddressId );
        this.delivery.ContractorAddresses.forEach(adr => {
            if(adr.Id == ContractorAddressId) {
                // console.log(adr );
                this.delivery.ChosenAdresses = adr;
            }
        });
        if(this.delivery.ChosenAdresses != null && this.delivery.ChosenAdresses.OtherTransportThenSelt && this.delivery.DeliveryMethod.Id == 3){
            this.delivery.ChosenAdresses = new DeliveryAddress(); 
          }
    }
    
   
    public dodajModul(formService,tresci, dialog: MatDialog){
        // console.log("bez auto dodaj modul");
        this.supervisor.auto = 0;
        this.moduly.push(new Modul());
        this.supervisor.aktualny_mod = this.moduly.length;
        this.supervisor.aktualna_poz = 0;
        this.supervisor.aktualnyTyp = TypEnum.ModuleHeader;
        this.wczytajKrok(formService, true, tresci, this.naglowek.GetLastStep().Step, dialog, this.naglowek.GetLastStep().Number, 0); 
        // console.log('moduł', this.supervisor.aktualny_mod);
    }
    public UsunModul(){
        this.moduly.splice(this.supervisor.aktualny_mod - 1,1);
        if(this.supervisor.aktualny_mod > 0){
            this.supervisor.aktualny_mod--;
        }
        this.poprawNumeryMod();
        this.stopka.WyczyscWszystko();
        // console.log("usuwam stopke 2");
    }
    
    
    public poprawNumeryMod() {
        for(var i = 0;i < this.moduly.length; i ++){
            this.moduly[i].moduleNg.kroki.forEach(mod => {
                mod.Module = i + 1;
                mod.Controlls.forEach(con => {
                    con.wybrany.Module = i + 1;
                });
                
            });
            this.moduly[i].pozycje.forEach(poz => {
                poz.kroki.forEach(mod => {
                    mod.Module = i + 1;
                    mod.Controlls.forEach(con => {
                        con.wybrany.Module = i + 1;
                    });
                    
                });
            });
            this.moduly[i].moduleFooter.kroki.forEach(mod => {
                mod.Module = i + 1;
                mod.Controlls.forEach(con => {
                    con.wybrany.Module = i + 1;
                });
                
            });
        }
        // console.log(this.moduly);
    }
    public poprawNumeryPoz() {
        // console.log("poprawion poz");
        // console.log(this.moduly);
        for(var i = 0;i < this.moduly.length; i ++){
            for(var m = 0;m < this.moduly[i].pozycje.length; m ++){
                this.moduly[i].pozycje[m].kroki.forEach(mod => {
                    mod.Position = m + 1;
                    mod.Controlls.forEach(con => {
                        con.wybrany.Position = m + 1;
                        if(con.ControlType === "File" || con.ControlType === "CheckFile"){
                            this.Files.forEach(file => {
                                // console.log("spr pozycje file", file.Position, m + 1, file, con.KeyName);
                                if(file.Key == con.KeyName && file.Id == con.wybrany.File.Id){
                                    // console.log("zmieniam pozycje file", file.Position, m + 1, file);
                                    file.Module = i + 1;
                                    file.Position = m + 1; 
                                }
                            });
                        }   
                        if(con.ControlType === "Pergola"){
                            this.Files.forEach(file => {
                                if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                                    file.Check = false;
                                }
                            });
                            this.Files.forEach(file => {
                                // console.log("spr pozycje file", file.Position, m + 1, file, con.KeyName);
                                if(file.Key == con.KeyName && file.FileName == con.pergola.file.FileName){
                                    // console.log("filename", file.FileName, con.pergola.file.FileName);
                                    // console.log("zmieniam pozycje file", file.Position, m + 1, file);
                                    file.Module = i + 1;
                                    file.Position = m + 1; 
                                    file.FileName = "Pergola " + (i+1) + "_" +(m+1)+".png";; 
                                    con.pergola.file.FileName = "Pergola " + (i+1) + "_" +(m+1)+".png";;  
                                    file.Check = true; 
                                }
                            });
                            this.Files.forEach(file => {
                                if(file.FileName.includes("Pergola ") && !file.Check && file.FileName.includes(".png")){
                                    file.Module = 9999999999;
                                    file.Position = 9999999999; 
                                    file.FileName = "Pergola " + 999999999999;
                                }
                            });
                        }   
                        con.Module = i + 1;
                        con.Position = m + 1;
                    });
                    
                });
            }
        }
    }

    public KopiujModul(){
        if(!this.wczytywanie){
    //this.moduly.push(JSON.parse(JSON.stringify(this.moduly[this.supervisor.aktualny_mod - 1])));
            //this.moduly.push(Object.assign({}, this.moduly[this.supervisor.aktualny_mod - 1]));
                // console.log("bez auto kopiuj mod");
            this.supervisor.auto = 0;
            this.moduly.push(_.cloneDeep(this.moduly[this.supervisor.aktualny_mod - 1]));
            
            
            this.supervisor.aktualny_mod = this.moduly.length; 
            this.poprawNumeryMod();
            // this.aktualny_mod--;
            // this.moduly.push(this.moduly[this.aktualny_mod]);
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 3");
        }
        
    }
    public ZmienModul(numer){
        if(!this.wczytywanie){
            this.supervisor.aktualny_mod = numer + 1;
        }
        
    }
    public getModNumber(parametry:Parameter[]){
        if(parametry.length > 0){
            return parametry[0].Module;
        }
        return -1;
    }

    public getPozNumber(parametry:Parameter[]){
        if(parametry.length > 0){
            return parametry[0].Position;
        }
        return -1;
    }

    public ustawKimStep(step:KrokStep){

        step.Controlls.forEach(con => {
            if(con.ControlType == 'Kim'){
                con.Values.forEach(val => {
                    val.Module = step.Module.valueOf(); //this.supervisor.getAktualnyMod();
                    val.Position = step.Position.valueOf() //this.supervisor.getAktualnaPoz();
                    // console.log("pozmod", val.Module, val.Position, this.supervisor.aktualny_mod);
                });
            } 
        });

    }
    public CzyPoprawnyAdres(){
        /*var adres_pop = this.czyPoprawneDelivery();
        if(this.supervisor.auto == 0 && !this.supervisor.wczytywanieAuto){
            setTimeout(()=> {
                if(!adres_pop && this.supervisor.zakladka != 0){
                    this.supervisor.zakladka = 0;
                    // console.log("wymuszono header", adres_pop);
                }
            }, 100);
        }
        */
        
        return this.czyPoprawneDelivery();
    }
    public uzupelnijParametry(czy_wymieniajX = true){
        var pppp = this.Parameters.find(x => x.Key == "UchwytSzyny");
        if(pppp){
            // console.log("przed", pppp.Value);
        }
        var param = this.GetParams();
        param.forEach(p => {
            var jest = this.Parameters.find(x => x.Key == p.Key && x.Module == p.Module && x.Position == p.Position);
            if(!jest){
                if(!(p.ControlName == "Hidden" && p.Value == "X")){
                    this.Parameters.push(p);
                } 
                // console.log("conttttt", p);
            } else if(!(p.ControlName == "Hidden" && p.Value == "X")) { // || !(p.ControlName == "Hidden" && p.Value == "X")){
                jest.DisplayValue = p.DisplayValue;
                jest.DisplayValueCs = p.DisplayValueCs;
                jest.DisplayValueDe = p.DisplayValueDe;
                jest.DisplayValueEn = p.DisplayValueEn;
                jest.DisplayValueFr = p.DisplayValueFr;
                jest.DisplayValueIt = p.DisplayValueIt;
                jest.DisplayValuePl = p.DisplayValuePl;
                jest.Value = p.Value;
            }
        });
        var pppp = this.Parameters.find(x => x.Key == "UchwytSzyny");
        if(pppp){
            // console.log("po", pppp.Value);
        }
        // console.log("Parametry", this.Parameters);
    }
    public wymienKrok(krok:KrokStep){
        //  // console.log("wymieniony krok", krok); 
        var wymaga_odswiezenia = false;
        this.uzupelnijParametry(false);
        // console.log("files", this.Files); 
        var step:KrokStep = new KrokStep(krok, this.Parameters, this.Files);
        this.ustawKimStep(step);
        this.IsFooter = step.IsFooter;
        this.IsModule = step.IsModule;
        this.IsModuleFooter = step.IsModuleFooter;
        this.TechVersion = step.TechVersion;
        this.ValuationVersion = step.ValuationVersion;
        // console.log("krok",this.AktualneKroki().kroki);
        // console.log("kroks",step);
        this.AktualneKroki().kroki.forEach(k => {
            if(k.Step == step.Step){
                //k.Controlls = step.Controlls;
                if(this.wymienKrok2(k, step)){
                    wymaga_odswiezenia = true;
                }
            }
        });
        
        return wymaga_odswiezenia;
        
    }

    public wymienKrok2(krokEdytowany:KrokStep, krokNowy:KrokStep){
        // console.log("wymień krok", krokNowy, krokEdytowany);
        
        krokEdytowany.czyPoprawne();
        var wymaga_odswiezenia = false;
        krokEdytowany.IsFooter = krokNowy.IsFooter;
        krokEdytowany.IsModule = krokNowy.IsModule;
        krokEdytowany.IsModuleFooter = krokNowy.IsModuleFooter;
        krokEdytowany.Module = krokNowy.Module;
        krokEdytowany.Parameters = krokNowy.Parameters;
        krokEdytowany.Position = krokNowy.Position;
        krokEdytowany.Step = krokNowy.Step;
        krokEdytowany.TechDate = krokNowy.TechDate;
        krokEdytowany.TechVersion = krokNowy.TechVersion;
        krokEdytowany.Type = krokNowy.Type;
        krokEdytowany.ValuationTechDate = krokNowy.ValuationTechDate;
        krokEdytowany.ValuationVersion = krokNowy.ValuationVersion;
                    
        krokEdytowany.Controlls.forEach(conE => {
            conE.wystapil = false;
            conE.bylPoprawny = conE.poprawne;
            
           // if(conE.KeyName == "KrajKlasaWiatru"){
            //    // console.log("conE", conE.wybrany.Value, conE.Values.length);
            //}
            if(!conE.poprawne && conE.wybrany != null &&  conE.wybrany.Value != null){
                if((conE.ControlType == "Number" || conE.ControlType == "CheckNumber" ) && (isNaN(conE.wybrany.Value) || conE.wybrany.Value == "" || !conE.poprawne) ){
                    
                } else {
                    conE.wybrany.Value = "X";
                }
                
            }
        });
        krokEdytowany.Controlls.forEach(conE => {
            krokNowy.Controlls.forEach(conN => {
                
                if(conN.KeyName == conE.KeyName){

                    conE.wystapil = true;
                    conE.zmianaTypu = false;
                    if(conE.ControlType != conN.ControlType){
                        if(conN.ControlType == "RadioImg"){
                            conE.ControlType = "Select";
                        } else {
                            conE.ControlType = conN.ControlType;
                        }
                        conE.zmianaTypu = true;
                    }
                    
                    
                    
                    
                    // console.log("wymień krok22", conN, krokEdytowany);
                    conE.DefaultValue = conN.DefaultValue;
                  if(conN.ControlType == "File"){
                    console.log("Values file", conE.Values, conN.Values );
                    }
                    try {
                        if(conN.ControlType != "File" || conE.Values == null || conE.Values.length == 0){
                                // console.log("wymień krok22", conN, conE); 
                                conE.Values = conN.Values;
                        }
                    
                    } catch(Exception){
                        if(conN.ControlType != "File"){
                                // console.log("wymień krok22", conN, conE); 
                                conE.Values = conN.Values;
                        }
                    }
                        
                    conE.ValuesMultiColumn = conN.ValuesMultiColumn;
                    conE.OtherParams = conN.OtherParams;
                    conE.Parameters = conN.Parameters;
                    conE.Hidden = conN.Hidden;
                    conE.Width = conN.Width;
                    conE.PictureWidth = conN.PictureWidth;
                    conE.PictureCode = conN.PictureCode;
                    conE.TranslateCode = conN.TranslateCode;
                    conE.ControlTypeInTinterpreter = conN.ControlTypeInTinterpreter;
                    conE.Section = conN.Section;
                    conE.Dynamic = conN.Dynamic;
                    conE.Row = conN.Row;
                    conE.Akapit = conN.Akapit;
                    conE.ForegrandColour = conN.ForegrandColour;
                    conE.BackgroundColour = conN.BackgroundColour;
                    conE.Size = conN.Size;
                    conE.IsPrint = conN.IsPrint;
                    
                    if(conN.ControlType == "Hidden" || conN.ControlType == "Label"){
                        conE.wybrany = conN.wybrany;
                    } else  //if(!conN.poprawne){
                        //conE.wybrany.Value = 'X';
                   // }
                   
                    if(conN.Dynamic && conE.wybrany.Value != conN.wybrany.Value){ //&& conN.wybrany.Value != conN.DefaultValue){
                        conE.wybrany = conN.wybrany;
                        conE.zmianaTypu = true;
                        wymaga_odswiezenia = true;
                        // console.log("nie poprawne 2", conE);
                        // console.log("nie poprawne 3", conN);
                    } if(conE.wybrany.Value != conN.wybrany.Value){
                        conE.wybrany = conN.wybrany;
                        conE.zmianaTypu = true;
                        // console.log("wymiana wybrany", conE.wybrany.Value);
                        // console.log("wymiana wybranyN2", conN.wybrany.Value);
                        if(conN.ControlType == "File"){
                            if(conE.Values.length > 0){
                                // console.log("wymiana wybranyK", conE.Values[0].Key);
                                // console.log("wymiana wybranyN", conN.Values[0].Key);
                                conE.Values[0].Key = conE.wybrany.Value;
                            }
                        }
                    }
                    if(conE.zmianaTypu){
                        conE.ChangeControlType();
                        conE.zmianaTypu = false;
                    }
                    /*if(conN.wybrany.Key == "OslonaRodzaj"){
                        // console.log("con", conE);
                        // console.log("con2", conN);
                    } */
                    
                }
            });
        });
        krokNowy.Controlls.forEach(conN => {
            var byl = false;
             krokEdytowany.Controlls.forEach(conE => {
                if(conN.KeyName == conE.KeyName){
                    byl = true;
                }
             });
             if(!byl){
                conN.wystapil = true;
                // if(conN.KeyName == "DomyślnySilnik"){
                    // console.log("poprawne???", conN.licznik);
                // }
                krokEdytowany.Controlls.push(conN);

                if(conN.Dynamic){
                    // console.log("wymień krokNNN", conN, krokEdytowany);
                    wymaga_odswiezenia = true;
                }
             }
        });
        krokEdytowany.Controlls.forEach(conE => {
            if(!conE.wystapil){
                conE.ControlType = "Usunieta";
                conE.wybrany.Value = "Usunieta";
            }
        });
        krokEdytowany.czyPoprawne();
        krokEdytowany.Controlls.forEach(conE => {
            
                //if(conE.KeyName == "DomyślnySilnik"){
                     //console.log("poprawne", conE.licznik);
                    // conE.BackgroundColour ="red";
                //}
            if(conE.poprawne != conE.bylPoprawny && conE.ControlType != "File"){
                // console.log("zmiana poprawności", krokEdytowany);
                wymaga_odswiezenia = true;
                conE.licznik++;
            } else if(!conE.poprawne && conE.licznik > 2 && conE.ControlType != "File"){
                wymaga_odswiezenia = false;
            } else if(!conE.poprawne){
                conE.licznik++;
            } else if(conE.poprawne){
                conE.licznik = 0;
            }
        });
        if(!wymaga_odswiezenia && this.formService != null){
             krokEdytowany.Controlls.forEach(con => {
                if(con.ControlType == "Render"){
                    
                    this.formService.getImg(this, con).pipe().subscribe(data => {
                        this.createImageFromBlob(data, con);
                       
                      }, error => {
                        con.src = '';
                      });
                }
            });

        } 
        return wymaga_odswiezenia;
    }

    public ustawKrok(krok:KrokStep){
        // console.log("krok", krok); 
        var wymaga_odswiezenia = false;
        this.uzupelnijParametry();
        // console.log("files", this.Files); 
        var step:KrokStep = new KrokStep(krok, this.Parameters, this.Files);
        this.ustawKimStep(step);
        this.IsFooter = step.IsFooter;
        this.IsModule = step.IsModule;
        this.IsModuleFooter = step.IsModuleFooter;
        this.TechVersion = step.TechVersion;
        this.ValuationVersion = step.ValuationVersion;
        // console.log("isfotherKrok", this.IsFooter);
        // console.log("isfotherKrok", this.IsFooter);
        if(step.Type == TypEnum.Header){
            if(this.naglowek.dodajKrok(step)){
                wymaga_odswiezenia = true;
            }
            this.naglowek.czyPoprawny();
            this.supervisor.SetAktualnyTyp('Header');
        } else if (step.Type == TypEnum.ModuleHeader){
            var mod = step.Module.valueOf();
            while(mod > this.moduly.length){
                this.moduly.push(new Modul());
            }
            
            if(this.moduly[mod - 1].moduleNg.dodajKrok(step)){
                wymaga_odswiezenia = true;
            }
            this.moduly[mod - 1].moduleNg.czyPoprawny();
            this.supervisor.aktualny_mod = mod;
            this.supervisor.SetAktualnyTyp('ModuleHeader');
            // this.aktualnyTyp = 'ModuleHeader';
        } else if (step.Type == TypEnum.Position){
            
            var mod = step.Module.valueOf(); //this.getModNumber(k.Parameters);
            while(mod > this.moduly.length){
                this.moduly.push(new Modul());
            }
            var poz = step.Position.valueOf(); //this.getPozNumber(k.Parameters);
            
            while(poz > this.moduly[mod - 1].pozycje.length){
                this.moduly[mod - 1].pozycje.push(new GrupaKrokow(TypEnum.Position));
            }
            // console.log("popoz", mod, poz,this.moduly.length, this.moduly[mod - 1].pozycje.length);
            if(!this.IsModule){
                this.moduly[mod - 1].moduleNg.poprawnie_zakonczone = true;
                this.moduly[mod - 1].moduleNg.edytowane = false;

            }
            // console.log(step,mod, poz);
            // console.log("ustawiam pozycje", step,  this.Parameters);
            if(this.moduly[mod - 1].pozycje[poz - 1].dodajKrok(step)){
                wymaga_odswiezenia = true;
            }
            this.moduly[mod - 1].pozycje[poz - 1].czyPoprawny();
            this.supervisor.aktualny_mod = mod;
            this.supervisor.aktualna_poz = poz;
            this.supervisor.SetAktualnyTyp('Position');
            this.supervisor.edycja_pozycji = true;
            // console.log(this.moduly);
            // this.aktualnyTyp = 'Position';
        } else if (step.Type == TypEnum.ModuleFooter){ 
            var mod = step.Module.valueOf(); //this.getModNumber(k.Parameters);
            while(mod > this.moduly.length){
                this.moduly.push(new Modul());
            }
            if(this.moduly[mod - 1].moduleFooter.dodajKrok(step)){
                wymaga_odswiezenia = true;
            }
            this.moduly[mod - 1].moduleFooter.czyPoprawny();
            this.supervisor.aktualny_mod = mod;
            // this.aktualnyTyp = 'ModuleFooter';
            this.supervisor.SetAktualnyTyp('ModuleFooter');
            
        } else if (step.Type == TypEnum.Footer){
            
            if(this.stopka.dodajKrok(step)){
                wymaga_odswiezenia = true;
            }
            this.stopka.czyPoprawny();
            this.stopka.edytowane = true;
           
            this.supervisor.aktualnyTyp = TypEnum.Footer;
            this.supervisor.SetAktualnyTyp('Footer');
            
            
            // this.ZmienZakladke(1);
            //this.supervisor.aktualnyTyp = TypEnum.Footer;
            //this.supervisor.SetAktualnyTyp('Footer');
        }
        // console.log("odśwież krok",krok,  wymaga_odswiezenia);
        return wymaga_odswiezenia;
    }
    public ustawKroki(kroki:KrokStep[], formService, dialog: MatDialog){
        // console.log("pp", kroki);
        var typ = TypEnum.Header;
        var mod = 0;
        var poz = 0;
        // console.log("isfother", this.IsFooter);
        if(kroki.length > 0){
            this.IsFooter = kroki[0].IsFooter;
        }
        if(this.IsFooter){
            this.supervisor.goToFooter = true;
        }
        
        //var j = 0 ;
        for (var i = 0; i < kroki.length; i++) {
            var con:Control;
            kroki[i].Controlls.forEach(c => {
                if(c.ControlType == 'Komunikat'){
                    con = c;
                }
                c.Module = this.supervisor.getAktualnyMod();
                c.Position = this.supervisor.getAktualnaPoz();
            });
            // console.log("pp con", kroki[i].Step, this.AktualneKroki().czyPoprawny());
            if(con != null){
                this.supervisor.wczytywanieAuto = false;
                this.wczytywanie = false;
                this.wczytywanie_block = false;
                // console.log("pp błąd ", kroki[i].Step,  this.AktualneKroki(), kroki[i],this.AktualneKroki(), this.AktualneKroki().czyPoprawny());
                    let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
                    const dataDial: DialogData = {
                    title: '',
                    content:  con.DefaultValue,
                    answerOk: true,
                    };
                    dialogRef = dialog.open(UniversalDialogComponent, { data: dataDial, role: 'alertdialog' });
                    // console.log("komunikat", this.AktualneKroki().edytowane, this.AktualneKroki().poprawnie_zakonczone);
                    this.AktualneKroki().poprawnie_zakonczone = false;
                    this.AktualneKroki().edytowane = true; 
                    
                    this.inspector.DodajError(this.typ_test, this.orderId, "Wystapił komunikat", con.DefaultValue);
                    break;
                
            } else if(kroki[i].Type == typ && kroki[i].Module == mod && kroki[i].Position == poz){
                //if(typ == TypEnum.Header || this.AktualneKroki().czyPoprawny()){
                // console.log("pp", kroki[i].Step, kroki[i], this.AktualneKroki().czyPoprawny());
                if(this.AktualneKroki().czyPoprawny()){
                    // console.log(kroki[i]);
                    // console.log("ustawia krok 5");  
                    this.ustawKrok(kroki[i]); 
                    
                } else {
                    
                    this.inspector.DodajError(this.typ_test, this.orderId, "Nie pasujące dane do kontrolek w kroku "+kroki[i].Step, kroki[i]);
                    // console.log("blad poz2?"); 
                } 
            } else {
                // console.log(this.AktualneKroki());
               
               //  // console.log("pp2", kroki[i].Step,  this.AktualneKroki(), kroki[i],this.AktualneKroki(), this.AktualneKroki().czyPoprawny());
                if(this.AktualneKroki().czyPoprawny()){
                   //if(j < 1){
                        //j++;
                    // console.log("ustawia krok 6");  
                        if(this.AktualneKroki().typ == TypEnum.Position && kroki[i].Type != TypEnum.Position){
                            this.moduly[this.supervisor.aktualny_mod - 1].zakonczono_pozycje = true;
                            
                        }
                        this.AktualneKroki().edytowane = false; 
                        this.AktualneKroki().poprawnie_zakonczone = true;

                        

                        this.supervisor.aktualna_poz = kroki[i].Position.valueOf();
                        this.supervisor.aktualny_mod = kroki[i].Position.valueOf();
                        this.supervisor.aktualnyTyp = kroki[i].Type;
                        typ = kroki[i].Type;
                        this.ustawKrok(kroki[i]); 
                    //}
                } else {
                   
                    this.inspector.DodajError(this.typ_test, this.orderId, "Niepoprawne dane w kroku: "+this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step, this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer]);
                     // console.log("blad poz3?"); 
                    this.AktualneKroki().edytowane = true;
                    this.AktualneKroki().poprawnie_zakonczone = false;
    
                    break;
                }
            }
        };
        
        if(this.moduly.length == 0 && this.naglowek.CzyZakonczony()){
            this.dodajModul(formService, null, dialog);
        }
        if(!this.IsModule && this.naglowek.CzyZakonczony()){
            this.moduly.forEach(mod => {
                mod.moduleNg.edytowane = false; 
                mod.moduleNg.poprawnie_zakonczone = true;

            });
        }
        if(!this.IsModuleFooter && this.naglowek.CzyZakonczony()){
            this.czyPoprawneDelivery();
            this.moduly.forEach(mod => {
                if(mod.moduleNg.CzyZakonczony()){
                    var poz_zakonczone = true;
                    mod.pozycje.forEach(poz => {
                        
                        if(!poz.CzyZakonczony()){
                            poz_zakonczone = false;
                        }
                        if(poz.kroki.length >= 1){
                           if(!poz.kroki[poz.kroki.length  - 1].czyPoprawne()){
                            poz.edytowane = true;
                            poz_zakonczone = false;
                            // console.log("błąd");
                           }
                        }
                    });
                    if(poz_zakonczone && mod.pozycje.length > 0){
                        mod.moduleFooter.edytowane = false; 
                        mod.moduleFooter.poprawnie_zakonczone = true;
                        // console.log("bez stopki", mod);
                        var poz_ok = true;
                        mod.pozycje.forEach(p => {
                            if(p.poprawnie_zakonczone == false || p.edytowane == true){
                                poz_ok = false;
                            }
                        });
                        if(poz_ok && !this.IsFooter){
                            this.supervisor.edycja_pozycji = false;
                            mod.zakonczono_pozycje = true;
                        }
                    }
                    
                }
                
            });
        }
        if(!this.IsFooter && this.naglowek.CzyZakonczony()){
            var mod_poprawne= true;
            this.moduly.forEach(mod => {
                if(!mod.moduleFooter.CzyZakonczony()){
                    mod_poprawne = false;
                }
            });
            if(mod_poprawne){
                this.stopka.edytowane = false; 
                this.stopka.poprawnie_zakonczone = true;
                this.inspector.DodajKoniec(this.typ_test, this.orderId);
            }
        }
        if(this.AktualneKroki().typ == TypEnum.Footer && this.AktualneKroki().CzyZakonczony()){
            this.AktualneKroki().edytowane = false; 
            this.AktualneKroki().poprawnie_zakonczone = true;
            
            this.inspector.DodajKoniec(this.typ_test, this.orderId);
        } else if(this.AktualneKroki().typ == TypEnum.Footer){
            // console.log("skonczylo na footer");
            this.next(null, formService, this.AktualneKroki().GetLastStep().Type, true, dialog);
        }
        if(this.AktualneKroki().typ != TypEnum.Position){
            this.supervisor.edycja_pozycji = false;
        }
        this.supervisor.goToFooter = false;
        // console.log("gotofooter", this.supervisor);
    }

   /* nextDelivery(){
        if(this.czyPoprawneDelivery()){
            //this.delivery.czyAdres = false;
            this.supervisor.aktualnyTyp = TypEnum.Header;
            
            return true;
        } else {
            return false;
        }
    }*/
    public GetPrevParams(){
        var p:Parameter[] = [];
           
           /*
        this.naglowek.kroki.forEach(k => {
            if(k.Module == this.supervisor.getAktualnyMod() && k.Position == this.supervisor.getAktualnaPoz() - 1){
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        p.push(con.wybrany);
                    }
                });
            }
        }); */
           
     
        this.moduly.forEach(m => {
            /*
            m.moduleNg.kroki.forEach(k => {
                if(k.Module == this.supervisor.getAktualnyMod() && k.Position == this.supervisor.getAktualnaPoz() - 1){
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            p.push(con.wybrany);
                        }
                    });
                }
            });*/
            m.pozycje.forEach(poz => {
                poz.kroki.forEach(k => {
                    if(k.Module == this.supervisor.getAktualnyMod() && k.Position == this.supervisor.getAktualnaPoz() - 1){
                        k.Controlls.forEach(con => {
                            if(con.wybrany.Key != 'X'){
                                p.push(con.wybrany);
                            }
                            if(con.ControlType == 'Pergola'){
                                var wartosci = con.pergola.getValues(k.Module, k.Position);
                                // console.log("parametry pergoli", wartosci);
                                wartosci.forEach(w => {
                                    p.push(w);
                                });
                                //this.DodajDoParam(p, con, k.Module, k.Position);
                            }
                        });
                    }
                });
            });
            /*
            m.moduleFooter.kroki.forEach(k => {
                if(k.Module == this.supervisor.getAktualnyMod() && k.Position == this.supervisor.getAktualnaPoz() - 1){
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            p.push(con.wybrany);
                        }
                    });
                }
            });*/
        });
        return p;
    }
    public GetAllParamsSave(){
        

        var p:Parameter[] = [];
      
        this.naglowek.kroki.forEach(k => {
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        con.wybrany.Position = 0;
                        con.wybrany.Module = 0;
                        con.wybrany.Type = 0;
                        
                        //p.push(con.wybrany);
                        this.DodajDoParamSave(p, con, 0 , 0);
                    }
                });
        });

        for(var i = 0;  i < this.moduly.length; i++){
            this.moduly[i].moduleNg.kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParamSave(p, con, i+1, 0);
                        }
                    });
            });

            for(var ip = 0; ip < this.moduly[i].pozycje.length; ip++){
                this.moduly[i].pozycje[ip].kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParamSave(p, con, i+1, ip+1);
                        }
                    });
                });
            }
            
            

            this.moduly[i].moduleFooter.kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParamSave(p, con, i+1, 0);
                        }
                    });
            });
        }
        
        
        
        this.stopka.kroki.forEach(k => {
                k.Controlls.forEach(con => {
                    // console.log("w stopce", con.wybrany);
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParamSave(p, con, 0, 0);
                    }
                });
        });
        // console.log("param", p);
        return p;
    }

    public Dodaj_wersje(p:Parameter[]){
        var par:Parameter = new Parameter();
        par.IsPrint = false;
        par.Module = 0;
        par.Position = 0;
        par.Value = this.TechVersion;
        par.DisplayValue = this.TechVersion;
        par.DisplayValueCs = this.TechVersion;
        par.DisplayValueDe = this.TechVersion;
        par.DisplayValueEn = this.TechVersion;
        par.DisplayValueFr = this.TechVersion;
        par.DisplayValuePl = this.TechVersion;
        par.DisplayValueIt = this.TechVersion;
        par.Type = 0;
        par.IsHidden = true;
        par.ControlName = 'Hidden';
        par.Key = "TechVersion";
        par.Disabled =false;
        p.push(par);

        if(this.byl_duplikat){
            var par2:Parameter = new Parameter();
            par2.IsPrint = false;
            par2.Module = 0;
            par2.Position = 0;
            par2.Value = "W zleceniu wystąpił duplikat";
            par2.DisplayValue = "W zleceniu wystąpił duplikat";
            par2.DisplayValueCs = "W zleceniu wystąpił duplikat";
            par2.DisplayValueDe = "W zleceniu wystąpił duplikat";
            par2.DisplayValueEn = "W zleceniu wystąpił duplikat";
            par2.DisplayValueFr = "W zleceniu wystąpił duplikat";
            par2.DisplayValuePl = "W zleceniu wystąpił duplikat";
            par2.DisplayValueIt = "W zleceniu wystąpił duplikat";
            par2.Type = 0;
            par2.IsHidden = true;
            par2.ControlName = 'Hidden';
            par2.Key = "Duplikat";
            par2.Disabled =false;
            p.push(par2);
        }
    }
    public GetAllParams(){
        
        this.duplikat = false;

        var p:Parameter[] = [];
        var wyliczane:Parameter[] = [];
        var wyliczane_mod:Parameter[] = [];
        var wyliczane_all:Parameter[] = [];
        

        this.Dodaj_wersje(p);

        this.id_parent = null;
        this.naglowek.kroki.forEach(k => {
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        con.wybrany.Position = 0;
                        con.wybrany.Module = 0;
                        con.wybrany.Type = 0;
                        
                        //p.push(con.wybrany);
                        con.wybrany.Type = 0;
                        this.DodajDoParam(p, con, 0 , 0);

                        if(con.wybrany.Key == 'IdParent'){
                           this.id_parent = con.wybrany.Value;
                        }

                    } else if(con.ControlType == 'CheckSelect' || con.ControlType == 'CheckNumber' || con.ControlType == 'CheckSelectMultiColumn'){
                        con.wybrany.Type = 0;
                        this.DodajDoParam(p, con, 0 , 0);
                    }
                });
        });
        // console.log("p", p);
        this.DodajParentParametrs(p, 0, 0, 0, 0);
        wyliczane_mod = [];
        wyliczane_all = [];
        var mod_parent = 0;
        for(var i = 0;  i < this.moduly.length; i++){
            this.moduly[i].moduleNg.kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, i+1, 0);
                            this.DodajAllModulDoPoz(p, con, i+1, 0);
                            this.DodajAllAutoSzerWys(p, con, i+1, 0);
                            this.WyliczDodatkoweMod(wyliczane_mod, con.wybrany);
                            con.wybrany.Type = 1;

                            if(con.wybrany.Key == 'IdParentMod'){
                                this.DodajParentParametrs(p, k.Module, 0, con.wybrany.Value, 0);
                               mod_parent = con.wybrany.Value;
                            }

                        } else if(con.ControlType == 'CheckSelect' || con.ControlType == 'CheckNumber' || con.ControlType == 'CheckSelectMultiColumn'){
                            con.wybrany.Type = 1;
                            this.DodajDoParam(p, con, i+1, 0);
                        }
                    });
            });



            wyliczane = [];
            for(var ip = 0; ip < this.moduly[i].pozycje.length; ip++){
                this.moduly[i].pozycje[ip].kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.ControlType == 'Pergola'){
                            var wartosci = con.pergola.getValues(k.Module, k.Position);
                            // console.log("parametry pergoli", wartosci);
                            wartosci.forEach(w => {
                                p.push(w);
                            });
                            // console.log("per", con);
                        }
                        // console.log('p2', con.ControlType, con.KeyName);
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            con.wybrany.Type = 2;
                            this.DodajDoParam(p, con, i+1, ip+1);
                            this.WyliczDodatkowe(wyliczane, con.wybrany);
                            this.WyliczDodatkoweModZestaw(wyliczane_all, con.wybrany);
                            if(con.wybrany.Key == 'IdParentPoz'){
                                this.DodajParentParametrs(p, k.Module, k.Position, mod_parent, con.wybrany.Value);
                            }
                        } else if(con.ControlType == 'CheckSelect' || con.ControlType == 'CheckNumber' || con.ControlType == 'CheckSelectMultiColumn'){
                            con.wybrany.Type = 2;
                            this.DodajDoParam(p, con, i+1, ip+1);
                        }
                        

                    });
                });
                var par:Parameter = new Parameter();
                par.IsPrint = false;
                par.Module = i+1;
                par.Position = ip+1;
                par.Value = ip+1;
                par.DisplayValue = ip+1;
                par.DisplayValueCs = ip+1;
                par.DisplayValueDe = ip+1;
                par.DisplayValueEn = ip+1;
                par.DisplayValueFr = ip+1;
                par.DisplayValuePl = ip+1;
                par.DisplayValueIt = ip+1;
                par.Type = 2;
                par.IsHidden = true;
                par.ControlName = 'Hidden';
                par.Key = "Numerpozycji";
                par.Disabled =false;
                p.push(par);
                var par2:Parameter = new Parameter();
                par2.IsPrint = false;
                par2.Module = i+1;
                par2.Position = ip+1;
                par2.Value = i+1;
                par2.DisplayValue = i+1;
                par2.DisplayValueCs = i+1;
                par2.DisplayValueDe = i+1;
                par2.DisplayValueEn = i+1;
                par2.DisplayValueFr = i+1;
                par2.DisplayValuePl = i+1;
                par2.DisplayValueIt = i+1;
                par2.Type = 2;
                par.IsHidden = true;
                par2.Key = "Numermoduł";
                par2.ControlName = 'Hidden';
                par2.Disabled =false;
                p.push(par2);

            }
            
            
            wyliczane.forEach(w => {
                p.push(w);
            });
            

            this.moduly[i].moduleFooter.kroki.forEach(k => {
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            con.wybrany.Type = 3;
                            this.DodajDoParam(p, con, i+1, 0);
                            this.WyliczDodatkoweMod(wyliczane_mod, con.wybrany);
                        } else if(con.ControlType == 'CheckSelect' || con.ControlType == 'CheckNumber' || con.ControlType == 'CheckSelectMultiColumn'){
                            con.wybrany.Type = 3;
                            this.DodajDoParam(p, con, i+1, 0);
                            this.WyliczDodatkoweMod(wyliczane_mod, con.wybrany);
                        }
                    });
            });
        }
        
        wyliczane_mod.forEach(w => {
            p.push(w);
        });
        
        
        wyliczane_all.forEach(w => {
            p.push(w);
        });
        
        this.stopka.kroki.forEach(k => {
                k.Controlls.forEach(con => {
                    // console.log("w stopce", con.wybrany);
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        con.wybrany.Type = 4;
                        this.DodajDoParam(p, con, 0, 0);
                    }else if(con.ControlType == 'CheckSelect' || con.ControlType == 'CheckNumber' || con.ControlType == 'CheckSelectMultiColumn'){
                        con.wybrany.Type = 4;
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
        });

        this.DodajDodatkoweParam(p);

        // console.log("param", p);
        return p; //.filter(x => x.Value != "X");
    }
   
    public GetParams(){

        // console.log("generuje parametry");

        var p:Parameter[] = [];
        var wyliczane:Parameter[] = [];
        var wyliczane_mod:Parameter[] = [];
        // console.log();
        //public moduly:Modul[] = [];
        this.naglowek.kroki.forEach(k => {
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
        });
        // console.log("p1", p);
        // console.log("mod", this.moduly, this.supervisor.getAktualnyMod(), this.supervisor.getAktualnaPoz());
        wyliczane_mod = [];
        var mod_parent = 0;
        // console.log("generuje parametry 2 mod: " + this.supervisor.getAktualnyMod(), this.moduly);
        this.moduly.forEach(m => {
            var modules = [];
            m.moduleNg.kroki.forEach(k => {
                if(k.Module == this.supervisor.getAktualnyMod() && k.Position == 0){
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            // console.log("generuje parametry 3 - generuje dodatkowe", con );
                            this.DodajDoParam(p, con, k.Module, 0);
                            this.DodajModulDoPoz(p, con, k.Module, 0);
                            this.DodajAutoSzerWys(p, con, k.Module, 0);
                        }
                        if(con.wybrany.Key == 'IdParentMod'){
                             this.DodajParentParametrs(p, k.Module, 0, con.wybrany.Value, 0);
                            mod_parent = con.wybrany.Value;
                        }
                        /* if(con.ControlType == "Module"){
                            // console.log("m-", con);
                            if(con.wybrany.Value != null){
                                modules = con.wybrany.Value.split(",");
                                for(var i = 0;i< modules.length;i++){
                                    modules[i] = modules[i].split(":")[2];
                                }
                                if(modules.length > this.supervisor.getAktualnaPoz()){
                                   //  this.DodajDoParam(p, con, k.Module, this.supervisor.getAktualnaPoz());
                                }
                            }
                            // console.log("m2-", modules);
                        } */
                    });
                }
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        this.WyliczDodatkoweMod(wyliczane_mod, con.wybrany);
                    }
                });
            });
            m.pozycje.forEach(poz => {
                poz.kroki.forEach(k => {
                    if(k.Module == this.supervisor.getAktualnyMod() && k.Position == this.supervisor.getAktualnaPoz()){
                        k.Controlls.forEach(con => {

                            if(con.wybrany.Key != 'X'){
                                //p.push(con.wybrany);
                                this.DodajDoParam(p, con, k.Module, k.Position);
                                
                            }
                            if(con.wybrany.Key == 'IdParentPoz'){
                                 this.DodajParentParametrs(p, k.Module, k.Position, mod_parent, con.wybrany.Value);
                            }
                            if(con.ControlType == 'Pergola'){
                                var wartosci = con.pergola.getValues(k.Module, k.Position);
                                // console.log("parametry pergoli", wartosci);
                                wartosci.forEach(w => {
                                    p.push(w);
                                });
                                //this.DodajDoParam(p, con, k.Module, k.Position);
                            }
                        });
                    }
                });
            });

/*
            m.moduleNg.kroki.forEach(k => {
                if(k.Module == this.supervisor.getAktualnyMod() && k.Position == 0){
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            this.DodajAutoSzerWys(p, con, k.Module, 0);
                        }
                    });
                }
            });*/


            wyliczane = [];
            m.pozycje.forEach(poz => {
                poz.kroki.forEach(k => {
                    if(k.Module == this.supervisor.getAktualnyMod()){
                        k.Controlls.forEach(con => {
                            if(con.wybrany.Key != 'X'){
                                this.WyliczDodatkowe(wyliczane, con.wybrany);
                            }
                        });
                    }
                });
            });




            if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter || this.supervisor.aktualnyTyp == TypEnum.Position){
                wyliczane.forEach(w => {
                    p.push(w);
                });
            }
            m.moduleFooter.kroki.forEach(k => {
                if(k.Module == this.supervisor.getAktualnyMod() && k.Position == 0){
                    k.Controlls.forEach(con => {
                        if(con.wybrany.Key != 'X'){
                            //p.push(con.wybrany);
                            this.DodajDoParam(p, con, k.Module, 0);
                        }
                    });
                }
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        this.WyliczDodatkoweMod(wyliczane_mod, con.wybrany);
                    }
                });
            });


        });
        //if(this.supervisor.aktualnyTyp == TypEnum.Footer || this.supervisor.aktualnyTyp == TypEnum.ModuleFooter || this.supervisor.aktualnyTyp == TypEnum.Position){
            wyliczane_mod.forEach(w => {
                p.push(w);
            });
        //}
        
        this.stopka.kroki.forEach(k => {
            if((k.Module == 0 && k.Position == 0)){
                k.Controlls.forEach(con => {
                    if(con.wybrany.Key != 'X'){
                        //p.push(con.wybrany);
                        con.wybrany.Type = 4;
                        this.DodajDoParam(p, con, 0, 0);
                    }
                });
            }
        });




        this.DodajDodatkoweParam(p);
        this.DodajParentParametrs(p, 0, 0, 0, 0);




        return p;
    }
    DodajParentParametrs(p, mod, pos, modparent, posparent){
        // console.log("parent", this.parent_Parameters);
        this.parent_Parameters.forEach(param => {
            if(param.Module == modparent && param.Position == posparent){
                var par:Parameter = new Parameter();
                par.IsPrint = false;
                par.Module = mod;
                par.Position = pos;
                par.Value = param.Value;
                par.DisplayValue = param.DisplayValue;
                par.DisplayValueCs = param.DisplayValueCs;
                par.DisplayValueDe = param.DisplayValueDe;
                par.DisplayValueEn = param.DisplayValueEn;
                par.DisplayValueFr = param.DisplayValueFr;
                par.DisplayValuePl = param.DisplayValuePl;
                par.DisplayValueIt = param.DisplayValueIt;
                par.Type = param.Type;
                par.Key = "parent_"+param.Key;
                par.Disabled = false;
                par.IsHidden = true;
                par.ControlName = "Hidden";
                p.push(par);
            }
        });
    }
    DodajDodatkoweParam(p){


        if(this.delivery.ComplaintType != null){
            if(this.delivery.ComplaintType.Id == 1){
                var par:Parameter = new Parameter();
                par.IsPrint = false;
                par.Module = 0;
                par.Position = 0;
                par.Value = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValue = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueCs = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueDe = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueEn = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueFr = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValuePl = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueIt = this.delivery.ChosenComplaint.ComplaintNumber;
                par.Type = 0;
                par.Key = "ReklamacjaNumer";
                par.Disabled = false;
                par.IsHidden = true;
                par.ControlName = "Hidden";
                p.push(par);
            } else {
                var par:Parameter = new Parameter();
                par.IsPrint = false;
                par.Module = 0;
                par.Position = 0;
                par.Value = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValue = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueCs = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueDe = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueEn = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueFr = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValuePl = this.delivery.ChosenComplaint.ComplaintNumber;
                par.DisplayValueIt = this.delivery.ChosenComplaint.ComplaintNumber;
                par.Type = 0;
                par.Key = "NaprawaNumer";
                par.Disabled = false;
                par.IsHidden = true;
                par.ControlName = "Hidden";
                p.push(par);
            }
        }
       
        if(this.Valuation){
            var par_v:Parameter = new Parameter();
            par_v.IsPrint = false;
            par_v.Module = 0;
            par_v.Position = 0;
            par_v.Value = "TAK";
            par_v.DisplayValue = "TAK";
            par_v.DisplayValueCs = "TAK";
            par_v.DisplayValueDe = "TAK";
            par_v.DisplayValueEn = "TAK";
            par_v.DisplayValueFr = "TAK";
            par_v.DisplayValuePl = "TAK";
            par_v.DisplayValueIt = "TAK";
            par_v.Type = 0;
            par_v.Key = "Wycena";
            par_v.Disabled = false;
            par_v.IsHidden = true;
            par_v.ControlName = "Hidden";
            p.push(par_v);
        }
            var par_c:Parameter = new Parameter();
            par_c.IsPrint = false;
            par_c.Module = 0;
            par_c.Position = 0;
            par_c.Value = this.Contractor.Country;
            par_c.DisplayValue = this.Contractor.Country;
            par_c.DisplayValueCs = this.Contractor.Country;
            par_c.DisplayValueDe = this.Contractor.Country;
            par_c.DisplayValueEn = this.Contractor.Country;
            par_c.DisplayValueFr = this.Contractor.Country;
            par_c.DisplayValuePl = this.Contractor.Country;
            par_c.DisplayValueIt = this.Contractor.Country;
            par_c.Type = 0;
            par_c.Key = "Country";
            par_c.Disabled = false;
            par_c.IsHidden = true;
            par_c.ControlName = "Hidden";
            p.push(par_c);

        
       
    }
    DodajDoParamSave(p:Parameter[],wparam:Control, mod:Number, poz:Number){
           
       if(wparam.ControlType != "Pokaz" && wparam.ControlType != "Hidden" 
       && wparam.ControlType != "CheckFile"  && wparam.ControlType != "File" 
       && wparam.ControlType != "NewLine"
       && wparam.ControlType != "Label"
       && wparam.ControlType != "VarianticVisualization"
       && wparam.ControlType != "Pdf"
       && wparam.ControlType != "Kim" ){
            wparam.wybrany.IsPrint = wparam.IsPrint;
            wparam.wybrany.Module = mod.valueOf();
            wparam.wybrany.Position = poz.valueOf();
            wparam.wybrany.IsHidden = wparam.Hidden;
            wparam.wybrany.ControlName  =   wparam.ControlType;
            /*if(wparam.wybrany.Type == null){
                if(mod == 0 && poz == 0){
                    wparam.wybrany.Type =0;
                }
            }*/
            if(wparam.wybrany.Value != null){
                var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                if(index < 0){
                    var par = new Parameter();
                    par.Key = wparam.wybrany.Key;
                    par.Position = wparam.wybrany.Position;
                    par.Module = wparam.wybrany.Module;
                    par.Type = wparam.wybrany.Type;
                    par.Value = wparam.wybrany.Value;

                    p.push(par);

                } else {
                    var par = new Parameter();
                    par.Key = wparam.wybrany.Key;
                    par.Position = wparam.wybrany.Position;
                    par.Module = wparam.wybrany.Module;
                    par.Type = wparam.wybrany.Type;
                    par.Value = wparam.wybrany.Value;
                    p[index] = par;
                }
                
            }
            
        }

    }
    DodajAutoSzerWys(p:Parameter[],wparam:Control, mod:Number, poz:Number){
        if(wparam.ControlType == "Module"){
            if(wparam.wybrany.Value != null){
                var modules = wparam.wybrany.Value.split(",");
                if(modules.length >= this.supervisor.getAktualnaPoz() && this.supervisor.getAktualnaPoz() != 0){
                  
                    var byla_sz = false;
                    var byla_wys = false;
                    var byla_wysokosc = false;
                    var byla_wysokosc_przy_scianie = false;
                    for(var i = 0;i<this.supervisor.getAktualnaPoz() - 1;i++){

                        
                        if(!byla_wysokosc){
                            byla_wysokosc = true;
                            
                            var linia = this.Parameters.find(x => x.Key ==  "WysokośćDoBelek" && x.Module == mod.valueOf() && x.Position == i + 1);
                            // console.log("sprawdz wys", linia,i,  mod.valueOf(), this.Parameters);
                            if(linia != null){
                                // console.log("była WysokośćDoBelek w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "AutoWysokośćDoBelek";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                        }

                        if(!byla_wysokosc_przy_scianie){
                            byla_wysokosc_przy_scianie = true;
                            var linia = this.Parameters.find(x => x.Key ==  "WysPrzyScianie" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była WysPrzyScianie w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "AutoWysPrzyScianie";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                        }

                        if(!byla_wys && modules[i].split(":")[0]== modules[this.supervisor.getAktualnaPoz() - 1].split(":")[0]){
                            byla_wys = true;
                            var linia = this.Parameters.find(x => x.Key ==  "Wysięg" && x.Module == mod.valueOf() && x.Position == i + 1);
                            //var linia = p.find(x => x.Key ==  "Wysokość" && x.Module == mod.valueOf() && x.Position == i + 1);
                            // console.log(linia, mod.valueOf(), this.Parameters);
                            if(linia != null){
                                // console.log("była wysięg w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "AutoWysięg";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                        }
                        if(!byla_sz && modules[i].split(":")[1]== modules[this.supervisor.getAktualnaPoz() - 1].split(":")[1]){
                            byla_sz = true;
                            var linia = this.Parameters.find(x => x.Key ==  "Szerokość" && x.Module == mod.valueOf() && x.Position == i + 1);
                            // var linia = p.find(x => x.Key ==  "Szerokość" && x.Module == mod.valueOf() && x.Position == i + 1);
                            // console.log(linia,i,  mod.valueOf(), this.Parameters);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "AutoSzerokość";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                        }

                        ////////////////////////


                        if(modules[i].split(":")[1]== modules[this.supervisor.getAktualnaPoz() - 1].split(":")[1] && modules[i].split(":")[0]== modules[this.supervisor.getAktualnaPoz() - 1].split(":")[0] - 1){
                            var linia = this.Parameters.find(x => x.Key ==  "Slup3" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "up_Slup3";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                            var linia = this.Parameters.find(x => x.Key ==  "Slup4" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "up_Slup4";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                            
                            var linia = this.Parameters.find(x => x.Key ==  "Stopa3" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "up_Stopa3";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                            var linia = this.Parameters.find(x => x.Key ==  "Stopa4" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "up_Stopa4";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                            var linia = this.Parameters.find(x => x.Key ==  "Moduł" && x.Module == mod.valueOf() && x.Position == i + 1);
                            if(linia != null){
                                // console.log("była szerokość w poz M"+ i + "   --- " + linia.Value);
                                var par2:Parameter = new Parameter();
                                par2.IsPrint = false;
                                par2.Module = mod.valueOf();
                                par2.Position = this.supervisor.getAktualnaPoz();
                                par2.Value = linia.Value;
                                par2.DisplayValue = linia.Value;
                                par2.DisplayValueCs = linia.Value;
                                par2.DisplayValueDe = linia.Value;
                                par2.DisplayValueEn = linia.Value;
                                par2.DisplayValueFr = linia.Value;
                                par2.DisplayValuePl = linia.Value;
                                par2.DisplayValueIt = linia.Value;
                                par2.Type = 2;
                                par2.Key = "up_Moduł";
                                par2.IsHidden = true;
                                par2.ControlName = "Hidden";
                                p.push(par2);
                            }
                        }


                    }

                }
            }
        }
    }
    DodajModulDoPoz(p:Parameter[],wparam:Control, mod:Number, poz:Number){
       
            if(wparam.ControlType == "Module"){
                // console.log("m-", con);
                if(wparam.wybrany.Value != null){
                    var modules = wparam.wybrany.Value.split(",");
                    //for(var i = 0;i< modules.length;i++){
                     //   modules[i] = modules[i].split(":")[2];
                    //}
                    // console.log("dodaje auto1 ", modules.length, this.supervisor.getAktualnaPoz());
                    // if(modules.length >= this.supervisor.getAktualnaPoz() && this.supervisor.getAktualnaPoz() != 0){
                    if(modules.length >= this.supervisor.getAktualnaPoz() && this.supervisor.getAktualnaPoz() != 0){
                        // console.log("dodaje auto2 ");
                        // console.log("dodaje auto2 ");
                        // this.DodajDoParam(p, con, k.Module, this.supervisor.getAktualnaPoz());
                        var par:Parameter = new Parameter();
                        par.IsPrint = false;
                        par.Module = mod.valueOf();
                        par.Position = this.supervisor.getAktualnaPoz();
                        par.Value = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValue = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValueCs = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValueDe = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValueEn = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValueFr = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValuePl = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.DisplayValueIt = modules[this.supervisor.getAktualnaPoz() - 1].split(":")[2];
                        par.Type = 2;
                        par.Key = "AutoModuł";
                        par.IsHidden = true;
                        par.ControlName = "Hidden";
                        p.push(par);
                        

                    }
                }
            }

    }
    DodajAllAutoSzerWys(p:Parameter[],wparam:Control, mod:Number, poz:Number){
        // console.log("dodaje auto");
        if(wparam.ControlType == "Module"){
            var szer:number[] = [];
            var wys:number[] = [];
            var WysokośćDoBelek = -1;
            var WysPrzyScianie = -1;
            // console.log("m-", con);
            if(wparam.wybrany.Value != null){
                var modules = wparam.wybrany.Value.split(",");
                for(var i = 0;i< modules.length;i++){
                    ///////////////

                    var dane_mod = modules[i].split(":");
                    for(var j = 0;j< modules.length;j++){
                        // console.log("dane up", dane_mod);
                        var dane_mod_nad = modules[j].split(":");
                        if(dane_mod[1] == dane_mod_nad[1] && dane_mod[0] - 1 == dane_mod_nad[0]){
                            var linia = this.Parameters.find(x => x.Key ==  "Slup3" && x.Module == mod.valueOf() && x.Position == j + 1);
                            if(linia != null){
                                var par:Parameter = new Parameter();
                                par.IsPrint = false;
                                par.Module = mod.valueOf();
                                par.Position = i+1;
                                par.Value = linia.Value;
                                par.DisplayValue = linia.DisplayValue;
                                par.DisplayValueCs = linia.DisplayValueCs;
                                par.DisplayValueDe = linia.DisplayValueDe;
                                par.DisplayValueEn = linia.DisplayValueEn;
                                par.DisplayValueFr = linia.DisplayValueFr;
                                par.DisplayValuePl = linia.DisplayValuePl;
                                par.DisplayValueIt = linia.DisplayValueIt;
                                par.Type = 2;
                                par.Key = "up_Slup3";
                                par.IsHidden = true;
                                par.ControlName = "Hidden";
                                p.push(par);
                            }
                            var linia = this.Parameters.find(x => x.Key ==  "Slup4" && x.Module == mod.valueOf() && x.Position == j + 1);
                            if(linia != null){
                                var par:Parameter = new Parameter();
                                par.IsPrint = false;
                                par.Module = mod.valueOf();
                                par.Position = i+1;
                                par.Value = linia.Value;
                                par.DisplayValue = linia.DisplayValue;
                                par.DisplayValueCs = linia.DisplayValueCs;
                                par.DisplayValueDe = linia.DisplayValueDe;
                                par.DisplayValueEn = linia.DisplayValueEn;
                                par.DisplayValueFr = linia.DisplayValueFr;
                                par.DisplayValuePl = linia.DisplayValuePl;
                                par.DisplayValueIt = linia.DisplayValueIt;
                                par.Type = 2;
                                par.Key = "up_Slup4";
                                par.IsHidden = true;
                                par.ControlName = "Hidden";
                                p.push(par);
                            }
                        }
                    }

                    //////////////

                    var byl_szer = false;
                    var byl_wys = false;

                    var linia = this.Parameters.find(x => x.Key ==  "WysokośćDoBelek" && x.Module == mod.valueOf() && x.Position == i + 1);
                    if(WysokośćDoBelek == -1 && linia != null){
                        WysokośćDoBelek= linia.Value;
                        // console.log("WysokośćDoBelek " + i + " "+ linia.Value, linia);
                    } else if(WysokośćDoBelek != -1){
                        var par:Parameter = new Parameter();
                        par.IsPrint = false;
                        par.Module = mod.valueOf();
                        par.Position = i+1;
                        par.Value = WysokośćDoBelek;
                        par.DisplayValue = WysokośćDoBelek
                        par.DisplayValueCs = WysokośćDoBelek;
                        par.DisplayValueDe = WysokośćDoBelek;
                        par.DisplayValueEn = WysokośćDoBelek;
                        par.DisplayValueFr = WysokośćDoBelek;
                        par.DisplayValuePl = WysokośćDoBelek;
                        par.DisplayValueIt = WysokośćDoBelek;
                        par.Type = 2;
                        par.Key = "AutoWysokośćDoBelek";
                        par.IsHidden = true;
                        par.ControlName = "Hidden";
                        p.push(par);
                    }
                    var linia = this.Parameters.find(x => x.Key ==  "WysPrzyScianie" && x.Module == mod.valueOf() && x.Position == i + 1);
                    if(WysPrzyScianie == -1 && linia != null){
                        WysPrzyScianie= linia.Value;
                        // console.log("WysPrzyScianie " + i + " "+ linia.Value, linia);
                    } else if(WysPrzyScianie != -1){
                        var par:Parameter = new Parameter();
                        par.IsPrint = false;
                        par.Module = mod.valueOf();
                        par.Position = i+1;
                        par.Value = WysPrzyScianie;
                        par.DisplayValue = WysPrzyScianie
                        par.DisplayValueCs = WysPrzyScianie;
                        par.DisplayValueDe = WysPrzyScianie;
                        par.DisplayValueEn = WysPrzyScianie;
                        par.DisplayValueFr = WysPrzyScianie;
                        par.DisplayValuePl = WysPrzyScianie;
                        par.DisplayValueIt = WysPrzyScianie;
                        par.Type = 2;
                        par.Key = "AutoWysPrzyScianie";
                        par.IsHidden = true;
                        par.ControlName = "Hidden";
                        p.push(par);
                    }
                    


                    // console.log("wys-"+modules[i].split(":")[0]+"--");
                    while(wys.length < Number.parseInt(modules[i].split(":")[0])+1){
                        wys.push(-1);
                    }
                    // console.log("szer-"+modules[i].split(":")[1]+"--");
                    while(szer.length < Number.parseInt(modules[i].split(":")[1])+1){
                        szer.push(-1);
                    }
                    var linia = this.Parameters.find(x => x.Key ==  "Wysięg" && x.Module == mod.valueOf() && x.Position == i + 1);
                    // console.log("wys-"+modules[i].split(":")[0]+"--", linia);
                    if(linia != null){
                        if(wys[modules[i].split(":")[0]] == -1){
                            wys[modules[i].split(":")[0]] = linia.Value;
                            byl_wys = true;
                            // console.log("wys " + i + " "+ modules[i].split(":")[0]+" " + szer[modules[i].split(":")[0]], linia);
                        }
                    }
                    var linia = this.Parameters.find(x => x.Key ==  "Szerokość" && x.Module == mod.valueOf() && x.Position == i + 1);
                    if(linia != null){
                        if(szer[modules[i].split(":")[1]] == -1){
                            szer[modules[i].split(":")[1]] = linia.Value;
                            byl_szer = true;
                            // console.log("szer " + i + " "+ modules[i].split(":")[1]+" " + szer[modules[i].split(":")[0]], linia);
                        }
                        //wysięg
                    }
                    // console.log("szerwys", szer, wys);
                    if(!byl_szer && szer[modules[i].split(":")[1]] != -1){
                        var par:Parameter = new Parameter();
                        par.IsPrint = false;
                        par.Module = mod.valueOf();
                        par.Position = i+1;
                        par.Value = szer[modules[i].split(":")[1]];
                        par.DisplayValue = szer[modules[i].split(":")[1]];
                        par.DisplayValueCs = szer[modules[i].split(":")[1]];
                        par.DisplayValueDe = szer[modules[i].split(":")[1]];
                        par.DisplayValueEn = szer[modules[i].split(":")[1]];
                        par.DisplayValueFr = szer[modules[i].split(":")[1]];
                        par.DisplayValuePl = szer[modules[i].split(":")[1]];
                        par.DisplayValueIt = szer[modules[i].split(":")[1]];
                        par.Type = 2;
                        par.Key = "AutoSzerokość";
                        par.IsHidden = true;
                        par.ControlName = "Hidden";
                        p.push(par);
                    }
                    if(!byl_wys && wys[modules[i].split(":")[0]] != -1){
                        var par:Parameter = new Parameter();
                        par.IsPrint = false;
                        par.Module = mod.valueOf();
                        par.Position = i+1;
                        par.Value = wys[modules[i].split(":")[0]];
                        par.DisplayValue = wys[modules[i].split(":")[0]];
                        par.DisplayValueCs = wys[modules[i].split(":")[0]];
                        par.DisplayValueDe = wys[modules[i].split(":")[0]];
                        par.DisplayValueEn = wys[modules[i].split(":")[0]];
                        par.DisplayValueFr = wys[modules[i].split(":")[0]];
                        par.DisplayValuePl = wys[modules[i].split(":")[0]];
                        par.DisplayValueIt = wys[modules[i].split(":")[0]];
                        par.Type = 2;
                        par.Key = "AutoWysięg";
                        par.IsHidden = true;
                        par.ControlName = "Hidden";
                        p.push(par);
                    }
                }
            }


            
            // console.log("m2-", modules);
        }
    }
    DodajAllModulDoPoz(p:Parameter[],wparam:Control, mod:Number, poz:Number){
       
        if(wparam.ControlType == "Module"){
            // console.log("m-", con);
            if(wparam.wybrany.Value != null){
                var modules = wparam.wybrany.Value.split(",");
                for(var i = 0;i< modules.length;i++){
                    modules[i] = modules[i].split(":")[2];

                    var par:Parameter = new Parameter();
                    par.IsPrint = false;
                    par.Module = mod.valueOf();
                    par.Position = i+1;
                    par.Value = modules[i];
                    par.DisplayValue = modules[i];
                    par.DisplayValueCs = modules[i];
                    par.DisplayValueDe = modules[i];
                    par.DisplayValueEn = modules[i];
                    par.DisplayValueFr = modules[i];
                    par.DisplayValuePl = modules[i];
                    par.DisplayValueIt = modules[i];
                    par.Type = 2;
                    par.Key = "AutoModuł";
                    par.IsHidden = true;
                    par.ControlName = "Hidden";
                    p.push(par);
                }
               
                
            }
            // console.log("m2-", modules);
        }

}

    DodajDoParam(p:Parameter[],wparam:Control, mod:Number, poz:Number){
        if(wparam.wybrany.Value == null || wparam.wybrany.Module == null || wparam.wybrany.Position == null || wparam.wybrany.Type == null){
            // console.log(wparam);
        }
        if(wparam.ControlType === "File" || wparam.ControlType === "CheckFile"){
            wparam.wybrany.IsPrint = wparam.IsPrint;
            wparam.wybrany.Module = mod.valueOf();
            wparam.wybrany.Position = poz.valueOf();
            /*if(wparam.wybrany.Type == null){
                if(mod == 0 && poz == 0){
                    wparam.wybrany.Type =0;
                }
            }*/
            var par:Parameter = new Parameter();
            par.IsPrint = wparam.IsPrint;
            par.Module = mod.valueOf();
            par.Position = poz.valueOf();
            par.Value = wparam.wybrany.Value;
            par.DisplayValue = wparam.wybrany.DisplayValue;
            par.DisplayValueCs = wparam.wybrany.DisplayValueCs;
            par.DisplayValueDe = wparam.wybrany.DisplayValueDe;
            par.DisplayValueEn = wparam.wybrany.DisplayValueEn;
            par.DisplayValueFr = wparam.wybrany.DisplayValueFr;
            par.DisplayValuePl = wparam.wybrany.DisplayValueIt;
            par.DisplayValueIt = wparam.wybrany.DisplayValueIt;
            par.Type = wparam.wybrany.Type;
            par.Key = wparam.wybrany.Key;
            par.Disabled = wparam.wybrany.Disabled;
            par.IsHidden = wparam.Hidden;
            par.ControlName = wparam.ControlType;
            // console.log("par", par);
            if(par.Value != null){
                var tp_guid = par.Value;
                var new_guid = this.generateGuid();
                // console.log("generuje guid 1", new_guid);
                
                this.Files.forEach(file => {
                    if(file.Key == par.Key && file.Module == par.Module && file.Position == par.Position){
                        file.Id = new_guid;
                    }
                });
                wparam.wybrany.Value = new_guid;
                if(wparam.Values.length > 0){
                    wparam.Values[0].Key = new_guid;
                }
                par.Value = new_guid;

                // console.log("plik", par, this.Files, tp_guid);
                p.push(par);
            }
        } else if(wparam.ControlType != "Pokaz" && wparam.ControlType != "Usunieta" && wparam.poprawne){
            wparam.wybrany.IsPrint = wparam.IsPrint;
            wparam.wybrany.Module = mod.valueOf();
            wparam.wybrany.Position = poz.valueOf();
            wparam.wybrany.IsHidden = wparam.Hidden;
            wparam.wybrany.ControlName  =   wparam.ControlType;
            /*if(wparam.wybrany.Type == null){
                if(mod == 0 && poz == 0){
                    wparam.wybrany.Type =0;
                }
            }*/
          
            if(wparam.wybrany.Value != null){
                if(wparam.ControlType == "CheckNumber" || wparam.ControlType == "CheckSelect" || wparam.ControlType == 'CheckSelectMultiColumn'){
                    if(wparam.wybrany.Value != ''){
                        var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                        if(index < 0){
                            p.push(wparam.wybrany);
                        } else {
                            this.Duplikat(p, p[index]);
                            p[index] = wparam.wybrany;
                        }
                    }
                } else if(wparam.ControlType == "Number" || wparam.ControlType == "Text" ){
                    wparam.wybrany.DisplayValue = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueCs= wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueDe = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueEn = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueFr = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValueIt = wparam.wybrany.Value;
                    wparam.wybrany.DisplayValuePl = wparam.wybrany.Value;

                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                } else if(wparam.ControlType == "Pergola" ){
                    // console.log("par", wparam);
                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    wparam.wybrany.IsPrint = false;
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                } else {
                    // console.log("par", wparam);
                    var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                    if(index < 0){
                        p.push(wparam.wybrany);
                    } else {
                        this.Duplikat(p, p[index]);
                        p[index] = wparam.wybrany;
                    }
                }
                
                
            }

           
            /* else if(wparam.ControlType == "CheckNumber" || wparam.ControlType == "CheckSelect" || wparam.ControlType == 'CheckSelectMultiColumn'){
                // console.log("par null", wparam);
                wparam.wybrany.Value = '';
                wparam.wybrany.Key  =   wparam.KeyName;
                var index = p.findIndex(x => x.Key == wparam.KeyName && x.Module == wparam.wybrany.Module && x.Position == wparam.wybrany.Position);
                if(index < 0){
                    p.push(wparam.wybrany);
                } else {
                    p[index] = wparam.wybrany;
                }
            } */
            
                


        }

    }
    Duplikat(parametry: Parameter[], wybrany: Parameter) {
        // console.log("Dubel", wybrany);
        // this.duplikat = true;
        var p:Parameter = new Parameter();
        p.Key = "duplikat_"+wybrany.Key;
        p.Value = wybrany.Value;
        p.DisplayValue = wybrany.Value;
        p.DisplayValueCs = wybrany.Value;
        p.DisplayValueDe = wybrany.Value;
        p.DisplayValueEn = wybrany.Value;
        p.DisplayValueFr = wybrany.Value;
        p.DisplayValueIt = wybrany.Value;
        p.DisplayValuePl = wybrany.Value;
        p.Module = wybrany.Module;
        p.IsHidden = true;
        p.ControlName = 'Hidden';
        p.Position = wybrany.Position;
        p.Type = wybrany.Type;
        parametry.push(p); 
    }
    generateGuid() : string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

      WyliczDodatkoweModZestaw(wyliczane: Parameter[], wybrany: Parameter) {
        if (!isNaN(wybrany.Value)) {
            var suma = wyliczane.find(x=> x.Key == "allsuma_" + wybrany.Key);
            var min = wyliczane.find(x=> x.Key == "allmin_" + wybrany.Key);
            var max = wyliczane.find(x=> x.Key == "allmax_" + wybrany.Key);
            if(suma != null){
                suma.DisplayValue = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueCs = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueDe = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueEn = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueFr = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueIt = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValuePl = suma.Value*1+ wybrany.Value*1;  
                suma.Value = suma.Value*1+ wybrany.Value*1;  
            } else {
                var p:Parameter = new Parameter();
                p.Key = "allsuma_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.Module = 0;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p); 
            }
            if(min != null){
                if(wybrany.Value*1 < min.Value*1){ 
                    min.Value = wybrany.Value*1; 
                    min.DisplayValue = wybrany.Value*1;
                    min.DisplayValueCs = wybrany.Value*1;
                    min.DisplayValueDe = wybrany.Value*1;
                    min.DisplayValueEn = wybrany.Value*1;
                    min.DisplayValueFr = wybrany.Value*1;
                    min.DisplayValueIt = wybrany.Value*1;
                    min.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "allmin_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = 0;
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p);
            }
            if(max != null){
                if(wybrany.Value*1 > max.Value*1){
                    max.Value = wybrany.Value*1;
                    max.DisplayValue = wybrany.Value*1;
                    max.DisplayValueCs = wybrany.Value*1;
                    max.DisplayValueDe = wybrany.Value*1;
                    max.DisplayValueEn = wybrany.Value*1;
                    max.DisplayValueFr = wybrany.Value*1;
                    max.DisplayValueIt = wybrany.Value*1;
                    max.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "allmax_"+wybrany.Key;
                p.Value = wybrany.Value*1; 
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = 0;
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p);
            }
            
        }
    }

    WyliczDodatkoweMod(wyliczane: Parameter[], wybrany: Parameter) {
        if (!isNaN(wybrany.Value)) {
            var suma = wyliczane.find(x=> x.Key == "suma_" + wybrany.Key);
            var min = wyliczane.find(x=> x.Key == "min_" + wybrany.Key);
            var max = wyliczane.find(x=> x.Key == "max_" + wybrany.Key);
            if(suma != null){
                suma.DisplayValue = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueCs = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueDe = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueEn = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueFr = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueIt = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValuePl = suma.Value*1+ wybrany.Value*1;  
                suma.Value = suma.Value*1+ wybrany.Value*1;  
            } else {
                var p:Parameter = new Parameter();
                p.Key = "suma_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.Module = 0;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p); 
            }
            if(min != null){
                if(wybrany.Value*1 < min.Value*1){ 
                    min.Value = wybrany.Value*1; 
                    min.DisplayValue = wybrany.Value*1;
                    min.DisplayValueCs = wybrany.Value*1;
                    min.DisplayValueDe = wybrany.Value*1;
                    min.DisplayValueEn = wybrany.Value*1;
                    min.DisplayValueFr = wybrany.Value*1;
                    min.DisplayValueIt = wybrany.Value*1;
                    min.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "min_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = 0;
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p);
            }
            if(max != null){
                if(wybrany.Value*1 > max.Value*1){
                    max.Value = wybrany.Value*1;
                    max.DisplayValue = wybrany.Value*1;
                    max.DisplayValueCs = wybrany.Value*1;
                    max.DisplayValueDe = wybrany.Value*1;
                    max.DisplayValueEn = wybrany.Value*1;
                    max.DisplayValueFr = wybrany.Value*1;
                    max.DisplayValueIt = wybrany.Value*1;
                    max.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "max_"+wybrany.Key;
                p.Value = wybrany.Value*1; 
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = 0;
                p.Position = 0;
                p.Type = 0;
                wyliczane.push(p);
            }
            
        }
    }
    WyliczDodatkowe(wyliczane: Parameter[], wybrany: Parameter) {
        if (!isNaN(wybrany.Value)) {
            var suma = wyliczane.find(x=> x.Key == "suma_" + wybrany.Key);
            var min = wyliczane.find(x=> x.Key == "min_" + wybrany.Key);
            var max = wyliczane.find(x=> x.Key == "max_" + wybrany.Key);
            if(suma != null){
                suma.DisplayValue =suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueCs =suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueDe = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueEn = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueFr = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValueIt = suma.Value*1+ wybrany.Value*1;  
                suma.DisplayValuePl = suma.Value*1+ wybrany.Value*1;  
                suma.Value = suma.Value*1+ wybrany.Value*1;  
            } else {
                var p:Parameter = new Parameter();
                p.Key = "suma_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.Module = wybrany.Module;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Position = 0;
                p.Type = 3;
                wyliczane.push(p); 
            }
            if(min != null){
                if(wybrany.Value*1 < min.Value*1){ 
                    min.Value = wybrany.Value*1; 
                    min.DisplayValue = wybrany.Value*1;
                    min.DisplayValueCs = wybrany.Value*1;
                    min.DisplayValueDe = wybrany.Value*1;
                    min.DisplayValueEn = wybrany.Value*1;
                    min.DisplayValueFr = wybrany.Value*1;
                    min.DisplayValueIt = wybrany.Value*1;
                    min.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "min_"+wybrany.Key;
                p.Value = wybrany.Value*1;
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = wybrany.Module;
                p.Position = 0;
                p.Type = 3;
                wyliczane.push(p);
            }
            if(max != null){
                if(wybrany.Value*1 > max.Value*1){
                    max.Value = wybrany.Value*1;
                    max.DisplayValue = wybrany.Value*1;
                    max.DisplayValueCs = wybrany.Value*1;
                    max.DisplayValueDe = wybrany.Value*1;
                    max.DisplayValueEn = wybrany.Value*1;
                    max.DisplayValueFr = wybrany.Value*1;
                    max.DisplayValueIt = wybrany.Value*1;
                    max.DisplayValuePl = wybrany.Value*1;
                }
            } else {
                var p:Parameter = new Parameter();
                p.Key = "max_"+wybrany.Key;
                p.Value = wybrany.Value*1; 
                p.DisplayValue = wybrany.Value*1;
                p.DisplayValueCs = wybrany.Value*1;
                p.DisplayValueDe = wybrany.Value*1;
                p.DisplayValueEn = wybrany.Value*1;
                p.DisplayValueFr = wybrany.Value*1;
                p.DisplayValueIt = wybrany.Value*1;
                p.DisplayValuePl = wybrany.Value*1;
                p.IsHidden = true;
                p.ControlName = 'Hidden';
                p.Module = wybrany.Module;
                p.Position = 0;
                p.Type = 3;
                wyliczane.push(p);
            }
            
        }
    }
    odswiezKrok2(data, tresci, dialog, formService){
        this.ostatniKrok = data;
        this.wczytywanie = false;
        // console.log("wczyt1 - false");
         // console.log("odświeżam krok", data); 

        var wymaga_odswiezenia = false;
        var k:KrokStep = data;
        k.Module = this.supervisor.getAktualnyMod();
        k.Position = this.supervisor.getAktualnaPoz();
          var c:Control;
          k.Controlls.forEach(con => {
              if(con.ControlType == "Komunikat"){
                  c = con;
              }
              con.Module = this.supervisor.getAktualnyMod() - 1;
              con.Position = this.supervisor.getAktualnaPoz() - 1;
              // console.log("mod", con.Module, con.Position);
          });

          if(c!= null){
            this.wczytywanie = false;
            this.wczytywanie_block = false;
            this.supervisor.wczytywanieAuto = false; 
            
            this.inspector.DodajError(this.typ_test, this.orderId, "Wystapił komunikat", c.DefaultValue);
              let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
              const dataDial: DialogData = {
                title: '',
                content: c.DefaultValue,
                answerOk: true,
              };
              dialogRef = dialog.open(UniversalDialogComponent, { data: dataDial, role: 'alertdialog' });

          } else {

              //czy jest taki sam typ
              if(this.supervisor.aktualnyTyp == k.Type){
                  if(this.wymienKrok(k)){
                    wymaga_odswiezenia = true;
                  }
              }
             
          }
          // console.log("odśwież krok??",  wymaga_odswiezenia);
          return wymaga_odswiezenia;
    }
    wczytajKrok2(data, tresci, dialog, formService){
        this.ostatniKrok = data;
        this.wczytywanie = false;
        this.wczytywanie_block = false;
        // console.log("wczyt1 - false");
        // console.log("step", data, this); 

                        // console.log("xxx");
        //if(!this.useParts){

        //} else {
            
            
            
        //}
        var k:KrokStep = data;
        if(k.Step == ""){
            this.inspector.DodajKoniec(this.typ_test, this.orderId);
        }
        k.Module = this.supervisor.getAktualnyMod();
        k.Position = this.supervisor.getAktualnaPoz();
          var c:Control;
          k.Controlls.forEach(con => {
              if(con.ControlType == "Komunikat"){
                  c = con;
              }
              con.Module = this.supervisor.getAktualnyMod();
              con.Position = this.supervisor.getAktualnaPoz();
              // console.log("mod", con.Module, con.Position);
          });

          if(c!= null){
            this.supervisor.wczytywanieAuto = false;
            
                    this.inspector.DodajError(this.typ_test, this.orderId, "Wystapił komunikat", c.DefaultValue);
              let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
              const dataDial: DialogData = {
                title: '',
                content: c.DefaultValue,
                answerOk: true,
              };
              dialogRef = dialog.open(UniversalDialogComponent, { data: dataDial, role: 'alertdialog' });

          } else {

              //czy jest taki sam typ
              if(this.supervisor.aktualnyTyp == k.Type){
                // console.log("xxx 0", k.Type, this.supervisor.aktualnyTyp);
                  if(!this.ustawKrok(k)){
                    // console.log("widoczny", this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].czyWidoczny());
                    if(!this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].czyWidoczny()){
                        this.wczytajKrok(formService, this.isCache, tresci, null, dialog, 0, 0);
                    } else {
                        if(this.supervisor.auto.valueOf() > 0){
                            this.nextAuto(tresci, formService, true, dialog);
                        }
                    }
                  } else {
                    this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(),  this.GetLastStepNumber(), 0);
                  }
                  
              } else {
                // console.log("xxx xx", k.Type, this.supervisor.aktualnyTyp);
                  this.supervisor.ZakonczGrupeKrokow(this.AktualneKroki());
                  if(this.supervisor.auto.valueOf() > 0){
                      this.nextAutoEnd(tresci, formService, true, dialog, k);
                  } else {
                    
                      // console.log("ak", this.AktualneKroki());
                      k.Module = this.supervisor.getAktualnyMod();
                      k.Position = this.supervisor.getAktualnaPoz();
                      if(this.supervisor.aktualnyTyp == TypEnum.Header){
                          if(this.moduly.length == 0){
                              if(k.Type == TypEnum.ModuleHeader){
                                  k.Module = 1;
                                  k.Position = 0;
                                  if(this.ustawKrok(k)){
                                        this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(),  this.GetLastStepNumber(), 0);
                                  }
                              } else if(k.Type == TypEnum.Position){
                                  k.Module = 1;
                                  k.Position = 1;
                                  if(this.ustawKrok(k)){
                                        this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(),  this.GetLastStepNumber(), 0);
                                  }
                              }
                          } else {
                              for(var i = 0;i < this.moduly.length;i++){
                                  if(k.Type == TypEnum.ModuleHeader){
                                      if(this.moduly[i].moduleNg.kroki.length == 0){
                                          k.Module = i+1;
                                          k.Position = 0;
                                          if(this.ustawKrok(k)){
                                                this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(), this.GetLastStepNumber(), 0);
                                          }
                                      }
                                  } else if(k.Type == TypEnum.Position){
                                      if(!this.IsModule){
                                          k.Module = i+1;
                                          k.Position = 1;
                                          if(this.ustawKrok(k)){
                                                this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(), this.GetLastStepNumber(), 0);
                                         }
                                      }
                                      //k.Module = i+1;
                                      //k.Position = 1;
                                      //this.ustawKrok(k);

                                  }
                              }
                          
                          }
                      

                          
                      } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader && this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length == 0){
                        // console.log("xxx 1");
                          if(k.Type == TypEnum.Position){
                              k.Position = 1;
                              if(!this.ustawKrok(k)){
                                    // console.log("widoczny2", this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].czyWidoczny());
                                    if(!this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].czyWidoczny()){
                                        this.wczytajKrok(formService, this.isCache, tresci, null, dialog, 0, 0);
                                    } else {
                                    /*  if(this.supervisor.auto.valueOf() > 0){
                                            this.nextAuto(tresci, formService, true, dialog);
                                        }*/
                                    }
                              } else {
                                this.odswiezKrok(formService, this.isCache, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(), this.GetLastStepNumber(), 0);
                              }

                              

                          }
                      } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter){

                          if(k.Type == TypEnum.Footer){
                              /*
                              k.Position = 0;
                              k.Module = 0;
                              if(this.stopka == null || this.stopka.kroki.length == 0){
                                  this.ustawKrok(k);
                              } else {
                                  this.supervisor.zakladka = 2;
                              }*/
                          } else {
                              
                          }
                      } else if(this.supervisor.aktualnyTyp == TypEnum.Position){
                           
                          if(k.Type == TypEnum.Footer){
                              
                              this.moduly[this.supervisor.aktualny_mod - 1].moduleFooter.poprawnie_zakonczone = true
                              this.moduly[this.supervisor.aktualny_mod - 1].moduleFooter.edytowane = false;
                              this.supervisor.edycja_pozycji = false; 
/*
                              k.Position = 0;
                              k.Module = 0;
                              if(this.stopka == null || this.stopka.kroki.length == 0){
                                  this.ustawKrok(k);
                              } else {
                                  this.supervisor.zakladka = 2;
                              } */
                          } else {
                              
                          }
                          
                      }
                  }
                  
                  
              /*  if(this.supervisor.ModulePositionForGetStep(k, this.AktualneKroki())){
                      if(k.Type == TypEnum.ModuleHeader){
                          if(this.moduly.length == 0){
                              this.ustawKrok(k);
                          } else {
                              
                              this.GenerujKrok(k); 
                          }
                      } else if(k.Type == TypEnum.Position){
                          
                          if(this.moduly.length == 0 || this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length == 0){
                              this.ustawKrok(k);
                          } else {
                              
                              this.GenerujKrok(k);
                          }
                      } else if(k.Type == TypEnum.ModuleFooter){
                          if(this.moduly.length == 0 || this.moduly[this.supervisor.aktualny_mod - 1].moduleFooter.kroki.length == 0){
                              this.ustawKrok(k);
                          } else {
                              
                              this.GenerujKrok(k);
                          }
                      }
                      //  this.ustawKrok(k);
                  } */
              }
              if(tresci != null){
                  // var x = this.moduly;
                  
                  if(k.Position.valueOf() > 0){
                      if(this.supervisor.auto.valueOf() != 2){
                          try {
                              tresci.scrollToPozycja('#krok_' + this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step);
                          } catch (Exception){
                              // console.log("błąd scrollowania 1");
                          }
                          
                      }
                      
                      //tresci.scrollToPozycja('#krok_' + this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step);
                  } else {
                      if(this.supervisor.auto.valueOf() != 2){
                          try {
                              tresci.scrollTo('#krok_' + this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step);
                          } catch (Exception){
                              // console.log("błąd scrollowania 2");
                          }
                          
                      }
                      
                  }
                  
                  
              } else {
                  // console.log("tresci null");
              }
          }
    }
    odswiezKrok(formService:FormV2ServiceService, isCache:boolean, tresci, step, dialog: MatDialog, auto, numer,  ilosc_b){
        // console.log("odswiezam", step);
        this.ZapiszParametry();
        if(this.wczytywanie){
            this.wczytajPotem = true;
        } else {
            this.wczytywanie = true;
            this.wczytajPotem = false;
            if(!this.useParts){
                numer = null;
            } else if(numer == null){
                numer = 0;
            }
            console.log("numer", numer);
            this.start = performance.now();
            formService.getStep(this.produktPrefix, this.culture, isCache, this.IsTrader,this.GetParams(),step, this.GetPrevParams(), numer).
            subscribe((data) => {
                var end = performance.now();
                // console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
                
                this.czas_wyk.unshift(this.licz_trw++ + `. Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
                if(this.czas_wyk.length > 10){
                    this.czas_wyk.pop();
                }
                var wymaga_odswiezenia = this.odswiezKrok2(data, tresci, dialog, formService);

                if(this.wczytajPotem || wymaga_odswiezenia){
                    this.wczytajPotem = false;
                    this.odswiezKrok(formService, isCache, tresci, step, dialog, auto, numer, 0);
                } else {
                    if(auto > 0){
                        // console.log("auto jest");
                        this.nextAuto(tresci, formService, false, dialog);
                    } else {
                        this.wczytywanie = false;
                    }
                }


            }, (err) => {
                this.wczytywanie = false;
                this.supervisor.wczytywanieAuto = false;

                if(ilosc_b > 2){
                    
                    this.inspector.DodajError(this.typ_test, this.orderId, "Błąd przy wczytywaniu technologi", err);
                    let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
                    const data: DialogData = {
                        title: 'błąd_połączenia',
                        content: 'błąd_połączenia_połączenie_przerwane',
                        answerOk: false,
                    };
                    dialogRef = dialog.open(UniversalDialogComponent, { data: data });
                    dialogRef.afterClosed().subscribe((result) => {
                        if (result === true) {
                            this.odswiezKrok(formService, isCache, tresci, step, dialog, auto, numer, 0);
                        } else {
                            this.wczytywanie = false;
                            this.wczytywanie_block = false;
                            this.supervisor.wczytywanieAuto = false; 
                        }
                    });
                } else {
                    this.odswiezKrok(formService, isCache, tresci, step, dialog, auto, numer, ilosc_b +1);
                }

                
            }, () => {
                // console.log("wczyt3 - false");
                // this.wczytywanie = false;
            }
            
            );
        }
        
    }
    getTech(formService:FormV2ServiceService, numer){
        formService.getTech(this.produktPrefix, this.culture, false, this.IsTrader, numer).
        subscribe((data) => {
            var tech:Technologia = new Technologia(data);
            tech.UstawParamInit(this.GetParams(), this.GetPrevParams());
            // console.log("technologia", tech);

        }, (err) => {
           
            // console.log("wczyt2 - false");
        }, () => {
            // console.log("wczyt3 - false");
            // this.wczytywanie = false;
        }
        
        );
    }
    wczytajKrok(formService:FormV2ServiceService, isCache:boolean, tresci:TresciService, step, dialog: MatDialog, numer, ilosc_b){
        
        this.wczytywanie = true;
        this.wczytywanie_block = true;
        // console.log("wczyt - true");
        if(step == null && this.AktualneKroki().kroki.length > this.AktualneKroki().akualnyNumer){
            step = this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step;
            numer = this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Number;
        }
        // console.log("FormData", this); 
        /*
        if(((this.supervisor.auto.valueOf() == 2 && !this.CzyWczytane) || (this.supervisor.auto.valueOf() == 1 && this.supervisor.byl_skip)) && this.AktualneKroki().akualnyNumer == 0){
            // console.log("moge multi", this.AktualneKroki().akualnyNumer, this.supervisor.aktualnyTyp, this.supervisor.aktualny_mod, this.supervisor.aktualna_poz);
            formService.getMultiStep(this.produktPrefix, this.culture, isCache, this.IsTrader,this.GetParams(),step, this.GetPrevParams(), this.supervisor.aktualnyTyp).
            subscribe((data) => {
                
                this.krokiTMP = data;
                this.numer_krokuTMP = 0;
                this.pozycjaTMP = this.supervisor.aktualna_poz;
                this.modulTMP = this.supervisor.aktualny_mod;
                //this. wczytajKrok2(data, tresci, dialog, formService);
            }, (err) => {
                // console.log("blad wczytywania");
                this.wczytywanie = false;
                this.supervisor.wczytywanieAuto = false;
                // console.log("wczyt2 - false");
            }, () => {
                // console.log("wczyt3 - false");
                // this.wczytywanie = false;
            });
        }
        */
        this.supervisor.byl_skip = false;

        this.ZapiszParametry();

        if(!this.useParts){
            numer = null;
        } else {
            if (localStorage.getItem('Cache') === 'nie') {
                this.isCache = false;
            } else {
                this.isCache = true;
            }
            
        }
        
        this.start = performance.now();
        formService.getStep(this.produktPrefix, this.culture, isCache, this.IsTrader,this.GetParams(),step, this.GetPrevParams(), numer).
        subscribe((data) => {
            var end = performance.now();
            // console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
            
            this.czas_wyk.unshift(this.licz_trw++ + `. Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
            if(this.czas_wyk.length > 10){
                this.czas_wyk.pop();
            }
           this.wczytajKrok2(data, tresci, dialog, formService);
        }, (err) => {
            
            // console.log("blad wczytywania");
             if(ilosc_b > 2){
                
                    this.inspector.DodajError(this.typ_test, this.orderId, "Błąd przy wczytywaniu technologi", err);
                 let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
                const data: DialogData = {
                    title: 'błąd_połączenia',
                    content: 'błąd_połączenia_połączenie_przerwane',
                    answerOk: false,
                };
                dialogRef = dialog.open(UniversalDialogComponent, { data: data });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result === true) {
                        this.wczytajKrok(formService, isCache, tresci, step, dialog, numer, 0);
                    } else {
                        this.wczytywanie = false;
                        this.wczytywanie_block = false;
                        this.supervisor.wczytywanieAuto = false; 
                    }
                });
             } else {
                this.wczytajKrok(formService, isCache, tresci, step, dialog, numer, ilosc_b+1);
             }
            

             
            // console.log("wczyt2 - false");
        }, () => {
            // console.log("wczyt3 - false");
            // this.wczytywanie = false;
        }
        
        );
    }
    GenerujKrok(krok:KrokStep){

    }
    public czyZakonczJakMozeszDodac(){
        var mozna = false;
        var bylo_mod = false;
        if(!this.IsModule){
            mozna = true;
        } 

        
        var czyNiest = false;
        if(this.naglowek.kroki.length > 0){
            this.naglowek.kroki.forEach(krok => {
                krok.Controlls.forEach(c => {
                  if(c.KeyName == 'JakaModułowość'){
                    if(c.wybrany.Value === 'TAK'){
                        czyNiest = true;
                    }
                  }
                });
              });
        }
        if(czyNiest){
            return true;
        }

        if(this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length > 0){
            this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.forEach(krok => {
              krok.Controlls.forEach(c => {
                if(c.KeyName == 'CzyModuł'){
                  if(c.wybrany.Value === 'TAK11' || c.wybrany.Value === 'MULTIMOD'){
                    mozna = true;
                  }
                  bylo_mod = true;
                }
              });
            });
          }
          if(!bylo_mod){
            mozna = true; 
          }
        return mozna;
    }
    public czyWielomodOK(){

        var czy_wielomod = false;
        var bylo_mod = false;
        var czyNiest = false;

        if(this.naglowek.kroki.length > 0){
            this.naglowek.kroki.forEach(krok => {
                krok.Controlls.forEach(c => {
                  if(c.KeyName == 'JakaModułowość'){
                    if(c.wybrany.Value === 'TAK'){
                        czyNiest = true;
                    }
                  }
                });
              });
        }
        if(czyNiest){
            return true;
        }


        if(this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length > 0){
            this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.forEach(krok => {
              krok.Controlls.forEach(c => {
                if(c.KeyName == 'CzyModuł'){
                  if(c.wybrany.Value === 'TAK' || c.wybrany.Value === 'TAK11' || c.wybrany.Value === 'TAKPT0405' || c.wybrany.Value === 'MULTIZIIP120' || c.wybrany.Value === 'MULTIMOD'  ){
                    czy_wielomod = true;
                  }
                  bylo_mod = true;
                }
              });
            });
          }


          if(czy_wielomod || !bylo_mod){
            return true;
          } else {
            if(this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length > 1 && this.IsModule){
                return false;
            } else {
                return true;
            }   
          } 
    }
    public czyAutoModuly(){
        var mod = this.GetParams().find(x => x.ControlName == 'Module');
        
        // console.log("czymod", mod);
        if(mod == null){
            return false;
        } else {
            return true;
        }
    }
    public czyMoznaDodacPozycje(){
        var wyb:string = '';


        var czyNiest = false;
        if(this.naglowek.kroki.length > 0){
            this.naglowek.kroki.forEach(krok => {
                krok.Controlls.forEach(c => {
                  if(c.KeyName == 'JakaModułowość'){
                    if(c.wybrany.Value === 'TAK'){
                        czyNiest = true;
                    }
                  }
                });
              });
        }
        if(czyNiest){
            return true;
        }


        if(this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length > 0){
          this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki.forEach(krok => {
            krok.Controlls.forEach(c => {
              if(c.KeyName == 'Moduł'){
                wyb = c.wybrany.Value;
              }
            });
          });
        }
        var czy_mozna = true;
        if(wyb === ''){
            czy_mozna = true;
        } else if(wyb === 'P1' || wyb === 'DP1' || wyb === 'D11'){
          czy_mozna = false;
        } else if(wyb === '11'){
          if(this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length > 0){
            this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.forEach(krok => {
              krok.Controlls.forEach(c => {
                if(c.KeyName == 'CzyModuł'){
                  if(!(c.wybrany.Value === 'TAK11')){
                    czy_mozna = false;
                  }
                }
              });
            });
          }
        }
        
       return czy_mozna;
        
      }

    NextExist(){
        return this.AktualneKroki().czyJestNext();
    }
    nextAutoEnd(tresci, formService:FormV2ServiceService, czyscroll = true, dialog: MatDialog, k:KrokStep){
         // console.log("end", this.supervisor.aktualnyTyp);
                        // console.log("autoend 1");
        if(k != null && k.Step == ''){
            this.supervisor.wczytywanieAuto = false;
        }
        if(this.supervisor.aktualnyTyp == TypEnum.Header){
            //this.supervisor.aktualny_mod = 1;
            //this.supervisor.aktualna_poz = 0;
            if(k != null){
                k.Module = this.supervisor.getAktualnyMod();
                k.Position = this.supervisor.getAktualnaPoz();
                
                    if(k.Type == TypEnum.ModuleHeader){
                        k.Module = 1;
                        k.Position = 0;
                        if(this.moduly[k.Module.valueOf() - 1].moduleNg.kroki.length == 0){
                            if(!this.ustawKrok(k)){
                                this.nextAuto(tresci, formService, czyscroll, dialog);
                            } else {
                                this.odswiezKrok(formService, true, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(), this.GetLastStepNumber(), 0);
                            }
                            
                        } else {
                            this.supervisor.SetAktualnyTyp(TypEnum.ModuleHeader);
                            this.supervisor.aktualny_mod = 1;
                            this.supervisor.wczytywanieAuto = false;
                            
                        }
                    } else if(k.Type == TypEnum.Position){
                        // console.log("Position 1");
                        k.Module = 1;
                        k.Position = 1;
                        if(this.moduly[k.Module.valueOf() - 1].pozycje[k.Position.valueOf() - 1].kroki.length == 0){
                            if(!this.ustawKrok(k)){
                                this.nextAuto(tresci, formService, czyscroll, dialog);
                            } else {
                                this.odswiezKrok(formService, true, null, this.GetLastStepName(), dialog, this.supervisor.auto.valueOf(), this.GetLastStepNumber(), 0);        
                            }
                            
                        } else {
                            this.supervisor.SetAktualnyTyp(TypEnum.Position);
                            this.supervisor.aktualny_mod = 1;
                            this.supervisor.wczytywanieAuto = false;
                        }
                        
                    }
            } else {
               
                this.supervisor.aktualny_mod = 1;
                this.supervisor.aktualna_poz = 0;
                this.supervisor.aktualnyTyp = TypEnum.ModuleHeader;
                this.nextAuto(tresci, formService, czyscroll, dialog);
            }
            
            

            
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader){ 
            // console.log("następny po moduleheader");
            if(k != null && k.Type == TypEnum.Position){
                // console.log("pozycja po moduleheader");
                k.Module = this.supervisor.getAktualnyMod();
                k.Position = 1;
                // console.log("kroki 1", this.moduly[k.Module.valueOf() - 1].pozycje[k.Position.valueOf() - 1]);
               
                //if(this.moduly[k.Module.valueOf() - 1].pozycje[k.Position.valueOf() - 1].kroki.length == 0){
                    this.EdytujPozycje(tresci, formService, true, this.supervisor.getAktualnyMod() - 1, 0,dialog);
                    // this.nextAuto(tresci, formService, czyscroll, dialog);
                //}
/*


                if(this.moduly[k.Module.valueOf() - 1].pozycje[k.Position.valueOf() - 1].kroki.length == 0){
                    // console.log("ustawiam krok");
                    this.ustawKrok(k);
                    this.nextAuto(tresci, formService, czyscroll, dialog);
                } else {

                }*/
                
            } else {
                this.EdytujPozycje(tresci, formService, true, this.supervisor.getAktualnyMod(), 1,dialog);
                this.nextAuto(tresci, formService, czyscroll, dialog);
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position){ 
            // console.log("xxx");
            if(this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length > this.supervisor.getAktualnaPoz()){
                 
                // console.log("następna pozycja", this.supervisor.getAktualnyMod() - 1, this.supervisor.getAktualnaPoz());
                this.EdytujPozycje(tresci, formService, true, this.supervisor.getAktualnyMod() - 1, this.supervisor.getAktualnaPoz(),dialog); 
                // this.nextAuto(tresci, formService, czyscroll, dialog);
            } else {
                // console.log("zakoncz_poz", this.supervisor.getAktualnyMod() - 1, this.supervisor.getAktualnaPoz());
                this.supervisor.ZakonczPozycje(this.supervisor.getAktualnaPoz());
                setTimeout(()=> {
                    // console.log("tworze stopkę modułu", this.czyWielomodOK(), this.czyMoznaDodacPozycje());
                
                    if(this.moduly[this.supervisor.getAktualnyMod() - 1].CzyPozPoprawny() && (!this.czyMoznaDodacPozycje() || this.czyZakonczJakMozeszDodac()) && this.czyWielomodOK()){
                        this.moduly[this.supervisor.getAktualnyMod() - 1].zakonczono_pozycje = true; 
                         //this.moveToModuleFooter(this.supervisor.getAktualnyMod() - 1, formService, tresci,dialog);

                         if(this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.kroki.length == 0 && this.IsModuleFooter){
                            
                                this.supervisor.aktualnyTyp = TypEnum.ModuleFooter;
                                this.supervisor.aktualna_poz = 0;
                                this.WczytajModuleFooter(this.supervisor.getAktualnyMod() - 1, formService, tresci, dialog);
                            
                            
                        } else {
                
                            if(!this.IsModuleFooter){
                                this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.poprawnie_zakonczone = true;
                                this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.edytowane = false; 
                            }
                            if(this.moduly[this.supervisor.getAktualnyMod() - 1].CzyFtPoprawny()){
                                if(this.moduly.length > this.supervisor.getAktualnyMod()){
                                    // console.log("wczytaj następny moduł");
                                    this.supervisor.aktualny_mod++;
                                    this.supervisor.aktualna_poz= 0;
                                    this.supervisor.aktualnyTyp = TypEnum.ModuleHeader;
                                    //this.next(tresci, formService, TypEnum.ModuleHeader, true, dialog);
                                    if(this.moduly[this.supervisor.aktualny_mod - 1].moduleNg.kroki.length == 0){
                                        this.wczytajKrok(formService, true, tresci, this.naglowek.GetLastStep().Step, dialog, this.naglowek.GetLastStep().Number, 0); 
                                    } else {
                                        this.next(tresci,formService,this.supervisor.aktualnyTyp,czyscroll,dialog);
                                    }
                                   
                                } else {
                                    // console.log("wczytaj stopke");
                                    if(!this.CzyPoprawnyAdres()){
                                        this.supervisor.zakladka = 0; 
                                    }
                                    
                                    this.ZmienZakladke(2, formService,tresci, dialog);
                                    
                                    
                                    
                                }
                            } else {
                                // console.log("niepoprawna stopka modułu");
                            }
                        }

                    } else {
                        // console.log("nie mozna dodac stopki modułu");
                        this.supervisor.auto = 0;
                        this.supervisor.wczytywanieAuto = false;
                        this.moduly[this.supervisor.getAktualnyMod() - 1].zakonczono_pozycje = false; 
                    }
                }, 100);
                
               
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter){ 
            setTimeout(()=> {
                // console.log("stopka mod", this.moduly[this.supervisor.getAktualnyMod() - 1].CzyFtPoprawny());
                if(this.moduly[this.supervisor.getAktualnyMod() - 1].CzyFtPoprawny()){
                    if(this.moduly.length > this.supervisor.getAktualnyMod()){
                        // console.log("wczytaj następny moduł");
                        this.supervisor.aktualny_mod++;
                        this.supervisor.aktualna_poz= 0;
                        this.supervisor.aktualnyTyp = TypEnum.ModuleHeader;
                        //this.next(tresci, formService, TypEnum.ModuleHeader, true, dialog);
                        if(this.moduly[this.supervisor.aktualny_mod - 1].moduleNg.kroki.length == 0){
                            this.wczytajKrok(formService, true, tresci, this.naglowek.GetLastStep().Step, dialog, this.naglowek.GetLastStep().Number, 0); 
                        } else {
                            // this.next(tresci,formService,this.supervisor.aktualnyTyp,czyscroll,dialog);
                        }
                        
                    } else {
                        // console.log("wczytaj stopke"); 
                        if(!this.CzyPoprawnyAdres()){
                            this.supervisor.zakladka = 0; 
                        }
                        
                        this.ZmienZakladke(2, formService,tresci, dialog);
                    }
                } else {
                    // console.log("niepoprawna stopka modułu");
                }
            }, 100);

                
        }


       /* if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader || this.supervisor.aktualnyTyp == TypEnum.Header ){
            this.supervisor.nastepnyTyp();
            this.supervisor.aktualny_mod = 1;
            this.supervisor.aktualna_poz = 0;
            this.AktualneKroki().akualnyNumer = 0;
            this.supervisor.EdytujPozycje(this.supervisor.aktualna_poz);
            if(this.AktualneKroki().kroki.length == 0){
                this.wczytajKrok(formService, true, tresci, this.moduly[this.supervisor.aktualny_mod - 1].moduleNg.GetLastStep().Step, dialog); 
            } 
            
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position){
            this.next(tresci, formService, TypEnum.Position, true, dialog);
        } */
        // this.next(tresci, formService, this.AktualneKroki().GetLastStep().Type, true, dialog);
        //
    }
    nextAuto(tresci, formService:FormV2ServiceService, czyscroll = true, dialog: MatDialog){
        // console.log("mid", this.supervisor.aktualna_poz, this.supervisor.aktualny_mod);
        this.next(tresci, formService, this.AktualneKroki().GetLastStep().Type, true, dialog);
        try {
        } catch (Exception){
            // console.log("błąd przy wczytywaniu automatycznym");
        }
       
    }


    generateImage(control, FormData, next, tresci, formService:FormV2ServiceService, typ, czyscroll = true, dialog: MatDialog){
       
        this.wczytywanie = true;
    try {
        control.pergola.setScaleStd();
        control.pergola.slupy.forEach(s => {
          s.ustaw_wym();
        });
        control.pergola.JakiWymiar();
    var img = "";
        var node:any = document.getElementById('Pergola'+control.pergola.random);
        htmlToImage.toPng(node, {pixelRatio:5})
          .then(function (dataUrl) {
            // var link = document.createElement('a');
            //link.download = 'screen.png';
            //link.href = dataUrl;
            img = dataUrl;
            //link.click(); 
          })
          .catch(function (error) {
            console.error('oops, something went wrong!', error);
            
            this.wczytywanie = false;
          }).finally(() => {
            // console.log("test ttt", img);
            
            // console.log("zapisał1");
            const contentType = 'image/png';
    
            // console.log("zapisał1a", img);
            var f = img.split("base64,");
            //var f = img.split("charset=utf-8,");
           //  // console.log("zapisał1aa", f);
          const byteCharacters = atob(f[1]);
          // console.log("zapisał1b");
          const byteNumbers = new Array(byteCharacters.length);
           // console.log("zapisał1c");
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          // console.log("zapisał2");
          const byteArray = new Uint8Array(byteNumbers);
          // const blob = new Blob([byteArray], {type: ""});
          const blob = new Blob([byteArray], {type: contentType});
          // this.control.src = blob;
          // this.createImageFromBlob(blob); 
          //this.control.pergola.file = blob;
            // if(this.control.wybrany.File == null){
             //  this.control.wybrany.File = new FileControl();
            // }
            // console.log("zapisał3");
            var newfile = new FileControl();
            newfile.FileName = "Pergola " + control.Module + "_" + control.Position+".png";
            newfile.Module = control.Module.valueOf();
            newfile.Position = control.Position.valueOf();
            newfile.Key = control.KeyName;
            newfile.Id = FormData.generateGuid();
            newfile.File = blob;
            
    
             // console.log("zapisał4");
    
            var x = FormData.Files.find((x: FileControl) => x.FileName === newfile.FileName);
            if (x != null) {
              FormData.Files.splice(FormData.Files.indexOf(x), 1);
            }
            // console.log("zapisał5");
            control.pergola.id = newfile.Id;
            control.pergola.file = newfile;
            FormData.Files.push(newfile);
            control.pergola.file_aktualny = true;
             // console.log("zapisał6");
             if(next){
                // console.log("next", next);
                this.wczytywanie = false;
                this.next(tresci, formService, typ, czyscroll, dialog);
             }
    
           // if (this.FormData.Files.find((x: FileControl) => x.Key === this.control.wybrany.File.Key)) {
            //  this.FormData.Files.splice(this.FormData.Files.indexOf(this.control.wybrany.File), 1);
            //}
            /*
            this.control.wybrany.File.File = blob;
            this.control.wybrany.FileName = "Pergola_"+this.control.KeyName;
            this.control.wybrany.File.FileName = "Pergola_"+this.control.KeyName+".png";
            this.FormData.Files.push(this.control.wybrany.File);
            
    
              this.FormData.Files.push(this.control.wybrany.File);*/
    
          }
          );
    } catch(Exception){
        // console.log("exception", Exception);
        this.wczytywanie = false;
    }
       
          
        
      }
public AktualizujPlikiPergola(modul, position){ //podajemy numery w których nastąpiła zmiana
    // console.log("pozycja", position);
    this.Files.forEach(file => {
        if(file.Module == modul && file.Position > position){
            if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                file.Position = 999999999;
                file.FileName = "Pergola 9999999999999";
            }
        } 
        if(file.Module == modul && file.Position == position){
            if(file.FileName.includes("Pergola ") && file.FileName.includes(".png")){
                var param = this.GetParams();
                // console.log("param", param);
                var jest = param.find(x => x.Key == file.Key && x.ControlName == "Pergola");
                // console.log("jest", jest);
                if(!jest){
                    file.Position = 999999999;
                    file.FileName = "Pergola 9999999999999";
                }
                
            }
        } 
    });
    this.Files = this.Files.filter(x => x.Position < 999999);
}

    next(tresci, formService:FormV2ServiceService, typ, czyscroll, dialog: MatDialog){
        // console.log("param w krok", this.Parameters);
        var blad_rys = false;
        this.AktualneKroki().kroki.forEach(k => {
            k.Controlls.forEach(c => {
                if(c.ControlType == "Pergola"){
                    if(!c.pergola.file_aktualny){
                        blad_rys = true;
                        this.generateImage(c, this, true, tresci, formService, typ, czyscroll, dialog);
                    }
                }
            });
        });
        if(blad_rys){
           // console.log("pominieto....");
           this.inspector.DodajError(this.typ_test, this.orderId, "Błąd rysunku", "Pergola");
        } else if(this.supervisor.bez_zmian && this.AktualneKroki().czyPoprawny()){
            this.supervisor.bez_zmian = false;
            this.AktualneKroki().edytowane = false;
            this.AktualneKroki().akualnyNumer = this.supervisor.prev_numer;
            
            this.supervisor.aktualnyTyp = this.supervisor.prev_type;
            this.supervisor.aktualny_mod = this.supervisor.prev_mod;
            this.supervisor.aktualna_poz = this.supervisor.prev_poz;
            this.AktualneKroki().edytowane = this.supervisor.prev_edit;
            // console.log("next auto 1", this.supervisor.prev_type, this.supervisor.prev_numer);
        } else {
            if(this.supervisor.auto.valueOf() == 2){
                this.supervisor.wczytywanieAuto = true;
            }
            
            // console.log("dialog3", dialog);
            this.supervisor.aktualnyTyp = typ;
            if(this.supervisor.aktualnyTyp == TypEnum.Adres){
                // console.log("del", this.delivery);
                if(!this.delivery.complaint_check || this.delivery.ChosenComplaint != null){
                     // console.log("d2", this.delivery);
                    if(this.czyPoprawneDelivery()){
                        // console.log("xxx");
                        this.delivery.AdressEdit = false;
                        this.supervisor.nastepnyTyp();
                    } else {
                        this.supervisor.wczytywanieAuto = false;
                    }
                } else {
                    this.supervisor.wczytywanieAuto = false; 
                }
            }
            
    
            if(this.NextExist()){
                // console.log("pop2", this.AktualneKroki().czyPoprawny());
                // this.supervisor.auto = false;
                if(this.AktualneKroki().czyPoprawny()){
                    this.AktualneKroki().nextWithoutInc();
    
    
                    if(!this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].czyWidoczny()){
                        this.next(tresci, formService, typ, czyscroll, dialog);
                    } else {
                        if(this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Position.valueOf() > 0) {
                            if(this.supervisor.auto.valueOf() != 2){
                                tresci.scrollToPozycja('#krok_' + this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step);
                            }
                           
                        } else {
                            if(this.supervisor.auto.valueOf() != 2){
                                tresci.scrollTo('#krok_' + this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step);
                            }
                            
                        }
                        if(this.supervisor.auto.valueOf() > 0){
                            this.nextAuto(tresci, formService,true,dialog);
                        }
                    }
                } else {
                    this.supervisor.wczytywanieAuto = false;
                    
                    // console.log("błąd danych 3");  
                }
                
            } else if (this.AktualneKroki().poprawnie_zakonczone){
                 console.log("kroki zakonczone ");
                if(this.AktualneKroki().czyPoprawny()){
                    // console.log("zakonczone ", this.supervisor.aktualnyTyp);
                    this.AktualneKroki().edytowane = false; 
                    if(this.supervisor.auto.valueOf() > 0){
                        // console.log("nextauto 99 ");
                        this.nextAutoEnd(tresci, formService,true,dialog, null);
                        // console.log("auto end 1");    
                    } else {
                        this.supervisor.nastepnyTyp();
                        // console.log("Następny typ");     
                    }
                } else {
                    // this.inspector.DodajError(this.orderId, "Niepoprawne dane w kroku", this.AktualneKroki().GetActualStep());
                    // console.log("błąd danych 1");                
                }
               
                
            } else {
                // console.log("kroki nie zakonczone ");
                if(this.supervisor.auto.valueOf() == 1){
                    this.CzyAuto(formService, tresci, dialog);
                }
                if(this.AktualneKroki().czyPoprawny()){
                    if(this.naglowek.kroki.length == 0) {
                        // console.log("k1");
                        // console.log("tutaj 1");
                            this.wczytajKrok(formService, false, tresci, null, dialog, 0, 0); 
                        
                    // console.log("wczytaj krok 1");   
                        
                    } else {
                        // console.log("k2");
                        // console.log("tutaj 2");
                        this.wczytajKrok(formService, true, tresci, null, dialog, 0, 0);  
                        // console.log("wczytaj krok 2");  
                    }
                    
                } else {
                        console.log("tutaj 3");
                        this.supervisor.wczytywanieAuto = false;
                        this.CzyAuto(formService, tresci, dialog);
                    // console.log("błąd danych 2");  
                    this.inspector.DodajError(this.typ_test, this.orderId, "Niepoprawne dane w kroku: "+this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Step, this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer]);
                     // console.log("nie uzupełnone dane");
                }
                
            }
        }

        


        return false;
        
    }
    public CzyAutoSkip(){
        if(this.supervisor.aktualnyTyp == TypEnum.Header) {
            if(this.naglowek.max_p > this.naglowek.akualnyNumer || this.moduly.length > 0){
               // this.supervisor.auto = true;
                return true;
            } else {
                this.supervisor.skip = false;
                return false;
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader) {
            if(this.AktualneKroki().max_p > this.AktualneKroki().akualnyNumer ||   this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length > 0){
                //this.supervisor.auto = true; 
                return true;
            } else {
                this.supervisor.skip = false;
                return false;
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position) {
            //var t = this.AktualneKroki();  
            if(this.supervisor.getAktualnaPoz() == 0 || this.supervisor.getAktualnaPoz() > this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length){
                return true;
            } else {
                if(this.AktualneKroki().max_p >  this.AktualneKroki().akualnyNumer || this.moduly.length > this.supervisor.aktualny_mod){
                    //this.supervisor.auto = true;
                    return true;
                } else {
                    this.supervisor.skip = false;
                    return false;
                }
            }
                
            
            
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter) {
            if(this.AktualneKroki().max_p  >  this.AktualneKroki().akualnyNumer || this.moduly.length > this.supervisor.aktualny_mod){
                //this.supervisor.auto = true;
                return true;
            } else {
                this.supervisor.skip = false;
                return false;
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.Footer) {
            if(this.AktualneKroki().max_p  >  this.AktualneKroki().akualnyNumer){
                //this.supervisor.auto = true;
                return true;
            } else {
                this.supervisor.skip = false;
                return false;
            }
        }
        return false;
    }
    public CzyAuto(formService, tresci, dialog){
        if(this.supervisor.aktualnyTyp == TypEnum.Header) {
            if(this.naglowek.max_p > this.naglowek.akualnyNumer || this.moduly.length > 0){
               // this.supervisor.auto = true;
            } else {
                // console.log("bez auto 1");
                this.supervisor.auto = 0;
                this.supervisor.wczytywanieAuto = false;
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader) {
            if(this.AktualneKroki().max_p > this.AktualneKroki().akualnyNumer ||   this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length > 0){
                //this.supervisor.auto = true; 
            } else {
                // console.log("bez auto 2");
                this.supervisor.auto = 0;
                this.supervisor.wczytywanieAuto = false;
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position) {
            var t = this.AktualneKroki();  
            
            // console.log(this.AktualneKroki().max_p, this.AktualneKroki().akualnyNumer, this.moduly.length, this.supervisor.aktualny_mod, this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length , this.supervisor.aktualna_poz);
            if(this.AktualneKroki().max_p > this.AktualneKroki().akualnyNumer || this.moduly.length > this.supervisor.aktualny_mod || this.moduly[this.supervisor.aktualny_mod - 1].pozycje.length > this.supervisor.aktualna_poz){
                //this.supervisor.auto = true;
            } else {
                if(this.IsModuleFooter){

                } else if(this.IsFooter) {
                    // this.ZmienZakladke(2, formService, tresci, dialog); 
                } else {
                    // console.log("bez auto 3");
                    this.supervisor.auto = 0;
                    this.supervisor.wczytywanieAuto = false;
                }
                
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter) {
            if(this.AktualneKroki().max_p  > this.AktualneKroki().akualnyNumer || this.moduly.length > this.supervisor.aktualny_mod){
                //this.supervisor.auto = true;
            } else {
                if(this.IsFooter) {
                    // this.ZmienZakladke(2, formService, tresci, dialog);
                } else {
                    // console.log("bez auto 4");
                    this.supervisor.auto = 0;
                    this.supervisor.wczytywanieAuto = false;
                }
                
            }
        } else if(this.supervisor.aktualnyTyp == TypEnum.Footer) {
            if(this.AktualneKroki().max_p  > this.AktualneKroki().akualnyNumer){
                //this.supervisor.auto = true;
            } else {
                // console.log("bez auto 5");
                this.supervisor.auto = 0;
                this.supervisor.wczytywanieAuto = false;
            }
        }
    }
    public CzyWczesniejszeUzupelnione(typ:string){ //nie używane
        if(typ == this.supervisor.aktualnyTyp){
            return true;
        } else if(this.supervisor.aktualnyTyp == TypEnum.Header){
            return false;
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader){
            if(typ == TypEnum.Header){
                return true;
            }
            return false;
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position){
            if(typ == TypEnum.Header || typ == TypEnum.ModuleHeader){
                return true;
            }
            return false;
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter){
            if(typ == TypEnum.Header || typ == TypEnum.Position || typ == TypEnum.ModuleHeader){
                return true;
            }
            return false;
        } else if(this.supervisor.aktualnyTyp == TypEnum.Footer){
            if(typ == TypEnum.Header || typ == TypEnum.Position || typ == TypEnum.ModuleHeader || typ == TypEnum.ModuleFooter){
                return true;
            }
            return false;
        }
    }
    ustawStr(){
        /*
        if(this.kroki[this.aktualnyStep].Type == "Header"){
            this.zakladka = 0;
        } else if(this.kroki[this.aktualnyStep].Type == "Position"){
            this.zakladka = 1;
        } else if(this.kroki[this.aktualnyStep].Type == "ModuleHeader"){
            this.zakladka = 1;
        } else if(this.kroki[this.aktualnyStep].Type == "ModuleFooter"){
            this.zakladka = 1;
        } else if(this.kroki[this.aktualnyStep].Type == "Footer"){
            this.zakladka = 2;
        }*/
    }
    goToLast(tresci){
       /* while(this.kroki.length > this.aktualnyStep + 1){
            if(!this.next(tresci, false)){
                // console.log("next");
                // console.log(this.kroki[this.aktualnyStep].Step, this.kroki);
                tresci.scrollTo("#krok_" + this.kroki[this.aktualnyStep].Step);
                break;
            } 
        } */
        
    }
    active(GrupaKrokow:GrupaKrokow, numer, module, position, typ){
        if(numer == -1){
            //this.delivery.czyAdres = true;
            // console.log('aaaa');
            this.delivery.AdressEdit = true;
            this.supervisor.SetAktualnyTyp(TypEnum.Adres);
            // console.log("bez auto adres");
             this.supervisor.auto = 0;
            //this.supervisor.wczytywanieAuto = false;
        } else {
            // this.supervisor.auto = true;
            this.supervisor.prev_edit = this.AktualneKroki().edytowane;
            this.supervisor.prev_type = this.supervisor.aktualnyTyp;
            this.supervisor.prev_mod = this.supervisor.aktualny_mod;
            this.supervisor.prev_poz = this.supervisor.aktualna_poz;
            if(typ != TypEnum.Footer){
                this.supervisor.bez_zmian = true;
            }
            
            


            this.supervisor.SetAktualnyTyp(typ); 
            this.supervisor.aktualny_mod = module;
            this.supervisor.aktualna_poz = position;
            this.supervisor.prev_numer = this.AktualneKroki().akualnyNumer; 
            this.AktualneKroki().akualnyNumer = numer; 
            this.AktualneKroki().edytowane = true;
            // console.log("bez auto active", typ);
            this.supervisor.auto = 0;


           //this.supervisor.wczytywanieAuto = false;
        }
       
        /*this.aktualnyStep = numer;*/
    }
    czyPoprawneDelivery(){
            // console.log("delivery", this.delivery);
            if(this.delivery.DeliveryMethod.Id != 0){
                if(!this.delivery.DeliveryMethod.IsDeliveryAddressRequired || (this.delivery.ChosenAdresses != null && this.delivery.ChosenAdresses.Id != 0)){
                    return true;
                } 
            } 
        return false;
    }
 
    
    public ZmienZakladke(numer, formService, tresci, dialog){
        // console.log("zak", this);
        if(numer == 1){
            if(this.supervisor.getAktualnyMod() == 0 || this.supervisor.getAktualnyMod() > this.moduly.length){
                
                    this.supervisor.aktualny_mod = this.moduly.length;
               
            }
            this.supervisor.SetAktualnyTyp(TypEnum.ModuleFooter);
        }
        if(!this.supervisor.edycja_pozycji){
            if(numer == 2){
                this.supervisor.aktualny_mod = 0;
                this.supervisor.aktualna_poz = 0;
                this.supervisor.SetAktualnyTyp(TypEnum.Footer);

                if(this.stopka == null || this.stopka.kroki.length == 0){
                    this.WczytajFooter(0, formService, tresci, dialog);
                } 
                // console.log("isfother123", this.IsFooter);
                    if(this.IsFooter){
                        this.supervisor.zakladka = 2;
                    }
                    
                

            } else if (numer == 0){
                this.supervisor.aktualny_mod = 0;
                this.supervisor.aktualna_poz = 0;
                this.supervisor.SetAktualnyTyp(TypEnum.Header);
                this.supervisor.zakladka = numer;
            } else {
                this.supervisor.zakladka = numer;
            }
                
          
            
        } else {
          
                this.supervisor.zakladka = 1;
            
        }
        
    }
    public AktualneKroki():GrupaKrokow {
        if(this.supervisor.aktualnyTyp == TypEnum.Header ){
            return this.naglowek;
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader){
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg;
        } else if(this.supervisor.aktualnyTyp == TypEnum.Position){
            return this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.supervisor.getAktualnaPoz() - 1];
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter){
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter;
        } else if(this.supervisor.aktualnyTyp == TypEnum.Footer){
            return this.stopka;
        }  else  {
            return new GrupaKrokow('');
        }

    }

    public CzyJestStep(numer, krok:KrokStep){
        var widoczny = false;
       // console.log(this.AktualneKroki(), numer);
        if(this.AktualneKroki().kroki.length > numer){
          /*  krok.Controlls.forEach(c => {
                if(c.ControlType != 'Hidden' && c.ControlType != 'NewLine') {
                  widoczny = true;
                }
              });*/
        } else {
            return  false;
        }
        
        return widoczny;
      }

      public zapiszParam2(p:Parameter){
        // console.log("zapisuje param2", this.Parameters);
        // console.log("zapisuje param2 par", p);
        if(!(p.ControlName == "Hidden" && p.Value == "X")){
            var byl:boolean = false;
            this.Parameters.forEach(param => {
                    if(param.Key == p.Key && param.Module == p.Module && param.Position == p.Position){
                        param = p;
                        byl = true;
                    }
            });
            if(!byl){
                
                this.Parameters.push(p);
            }
        }
      
      }
      public zapiszParam(control:Control){
        // console.log("params 1", this.Parameters);
        // console.log("params cont 1",  control);
        if(!(control.ControlType == "Hidden" && (control.wybrany == null || control.wybrany.Value == "X"))){
            control.wybrany.Key = control.KeyName;
            var byl:boolean = false;
            this.Parameters.forEach(param => {
                if(param.Key == control.KeyName && param.Module == this.supervisor.aktualny_mod && param.Position == this.supervisor.aktualna_poz){
                    param.DisplayValue = control.wybrany.DisplayValue;
                    param.DisplayValueCs = control.wybrany.DisplayValueCs;
                    param.DisplayValueDe = control.wybrany.DisplayValueDe;
                    param.DisplayValueEn = control.wybrany.DisplayValueEn;
                    param.DisplayValueFr = control.wybrany.DisplayValueFr;
                    param.DisplayValuePl = control.wybrany.DisplayValuePl;
                    param.Value = control.wybrany.Value;
                    byl = true;
                }
            });
            if(!byl){
                var p = new Parameter();
                p.Key = control.wybrany.Key;
                p.Value = control.wybrany.Value;
                p.Module = this.supervisor.aktualny_mod;
                p.Position = this.supervisor.aktualna_poz;
                this.Parameters.push(p);
            }
        }

        
            
        // console.log('param', this.Parameters);
      }
      
      public usunDalszePoz(numerPozycji:number){
         // console.log("usun dalsze poz");
         this.supervisor.bez_zmian = false;
         if(this.supervisor.auto.valueOf() == 0){
            this.supervisor.skip = true;
            this.CzyAutoSkip();
        }
        for(var i = this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1; i>=numerPozycji; i--){
            this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[i].WyczyscWszystko();
        }
        this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.WyczyscWszystko();
        if(this.supervisor.aktualnyTyp != TypEnum.Footer){
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 4");
        }
        
      }

      public usunDalsze(control:Control){
         // console.log("usun dalsze");
         this.supervisor.bez_zmian = false;
        if(this.supervisor.auto.valueOf() == 0){
            this.supervisor.skip = true;
            this.CzyAutoSkip();
        }
        this.AktualneKroki().WyczyscDalsze();
        if(this.supervisor.aktualnyTyp == TypEnum.Header){
            this.moduly.forEach(mod => {
                mod.moduleNg.WyczyscWszystko();
                mod.moduleFooter.WyczyscWszystko();
                mod.pozycje.forEach(poz => {
                    poz.WyczyscWszystko();
                });
            });
           
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 5");
            
            //this.stopka.WyczyscWszystko();
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleHeader){
            this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.forEach(poz => {
                poz.WyczyscWszystko();
            });
            this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.WyczyscWszystko();
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 6");
        }  else if(this.supervisor.aktualnyTyp == TypEnum.Position){
            for(var i = this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1; i>=this.supervisor.getAktualnaPoz(); i--){
                this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[i].WyczyscWszystko();
            }
            this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.WyczyscWszystko();
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 7");
        } else if(this.supervisor.aktualnyTyp == TypEnum.ModuleFooter){
            this.stopka.WyczyscWszystko();
            // console.log("usuwam stopke 8");
        }
      }
      ZmianaParametru(control:Control, formV2Service:FormV2ServiceService , dialog:MatDialog) {
        // console.log("zmiana parametrów");
        // console.log("zmiana", control);
       /* control.Values.forEach(v => {
            if(v.Key == control.wybrany.Value){
                control.wybrany.DisplayValue = v.DisplayValue;
                control.wybrany.DisplayValueCs = v.DisplayValueCs;
                control.wybrany.DisplayValueDe = v.DisplayValueDe;
                control.wybrany.DisplayValueEn = v.DisplayValueEn;
                control.wybrany.DisplayValueFr = v.DisplayValueFr;
                control.wybrany.DisplayValuePl = v.DisplayValuePl;
                control.wybrany.Key = v.Key;
            }
        }); */
            var param:Parameter[] = [];
            param = this.GetAllParams();

            this.zapiszParam(control);
            param.forEach(p => {
                this.zapiszParam2(p);
            });
            //this.Parameters = param;
            // console.log("zapis param", param);
        
        if(control.NotAffectToOtherControls == 0){
             // console.log("USUŃ DALSZE 1", control);
            this.usunDalsze(control);
        } else if(control.NotAffectToOtherControls == 2){
             // console.log("USUŃ DALSZE 2", control);
             
            this.supervisor.bez_zmian = false;
            if(this.supervisor.auto.valueOf() == 0){
                this.supervisor.skip = true;
                this.CzyAutoSkip();
            }
            
            this.AktualneKroki().WyczyscDalsze();
        } else {
            if(this.supervisor.aktualnyTyp != TypEnum.Footer){
                this.stopka.WyczyscWszystko(); 
                // console.log("usuwam stopke 9");
            }
        }
        // console.log("con", control);
        this.AktualneKroki().czyPoprawny();
        this.ZapiszParametry(param); 
        
        this.AktualneKroki().kroki[this.AktualneKroki().akualnyNumer].Controlls.forEach(con => {
                if(con.ControlType == "Render"){
               
                    formV2Service.getImg(this, con).pipe(/*take(1)*/).subscribe(data => {
                        this.createImageFromBlob(data, con);
                        //const dialogRef = this.dialog.open(this.imgDialog,  { minWidth: '1080px'});
                        // dialogRef.afterClosed().subscribe((result) => {
                        //    // console.log(`Dialog result: ${result}`);
                        // });
                      }, error => {
                        con.src = '';
                      });
                }
            });
        
            this.AktualizujPlikiPergola(this.supervisor.getAktualnyMod(), this.supervisor.getAktualnaPoz());
        

            
            if(control.Dynamic){
                
                // console.log('popraw tutaj', control);

                this.odswiezKrok(formV2Service, true, null, this.GetLastStepName(), dialog, 0, this.GetLastStepNumber(), 0);
            }

      }
      public GetLastStepName(){
        if(this.AktualneKroki().kroki.length > 1){
            // console.log("pob 1");
            return this.AktualneKroki().kroki[this.AktualneKroki().kroki.length - 2].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.Header){
            // console.log("pob Header");
            return null;
        } else if(this.AktualneKroki().typ ==TypEnum.ModuleHeader){
            // console.log("pob ModuleHeader");
            return this.naglowek.kroki[this.naglowek.kroki.length - 1].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.Position && this.IsModule){
             console.log("pob Position", this.supervisor.getAktualnyMod(), this.moduly);
            
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length - 1].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.Position){
             console.log("pob Position 2");
            return this.naglowek.kroki[this.naglowek.kroki.length - 1].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.ModuleFooter && this.IsModule){
            // console.log("pob ModuleFooter");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki.length - 1].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.Footer && this.IsModuleFooter){
            // console.log("pob Footer");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.kroki.length - 1].Step;
        } else if(this.AktualneKroki().typ ==TypEnum.Footer){
            // console.log("pob Footer 2");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki.length - 1].Step;
        } 
      }
      public  GetLastStepNumber(){
        if(this.AktualneKroki().kroki.length > 1){
            // console.log("pob 1");
            return this.AktualneKroki().kroki[this.AktualneKroki().kroki.length - 2].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.Header){
            // console.log("pob Header");
            return null;
        } else if(this.AktualneKroki().typ ==TypEnum.ModuleHeader){
            // console.log("pob ModuleHeader");
            return this.naglowek.kroki[this.naglowek.kroki.length - 1].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.Position && this.IsModule){
            // console.log("pob Position", this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length - 1].Number);
            
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].moduleNg.kroki.length - 1].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.Position){
            // console.log("pob Position 2");
            return this.naglowek.kroki[this.naglowek.kroki.length - 1].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.ModuleFooter && this.IsModule){
            // console.log("pob ModuleFooter");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki.length - 1].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.Footer && this.IsModuleFooter){
            // console.log("pob Footer");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].moduleFooter.kroki.length - 1].Number;
        } else if(this.AktualneKroki().typ ==TypEnum.Footer){
            // console.log("pob Footer 2");
            return this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje[this.moduly[this.supervisor.getAktualnyMod() - 1].pozycje.length - 1].kroki.length - 1].Number;
        } 
      }
      createImageFromBlob(image: Blob, con:Control) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          con.src = reader.result;
        }, false);
    
        if (image) {
          reader.readAsDataURL(image);
        }
      }
     

      ZapiszParametry(param:Parameter[] = null) {
        
        var formTMP = new FormDataV2(null, null, this.useParts);
        if(param == null){
            formTMP.Parameters = this.GetAllParams();
         // console.log("zapisuje parametry1", formTMP.Parameters);
        } else {
            formTMP.Parameters = param;
         // console.log("zapisuje parametry2", formTMP.Parameters);
        }
        // console.log("zapisuje parametry", formTMP.Parameters);
        formTMP.IsFooter = this.IsFooter;
        formTMP.IsModule = this.IsModule;
        formTMP.IsModuleFooter = this.IsModuleFooter;
        formTMP.IsTrader = this.IsTrader;
        formTMP.Order = this.Order;
        formTMP.delivery = this.delivery;


         //formTMP.Files = this.Files;


         // formTMP.Files = [];
         
        formTMP.ParameterExtensions = this.ParameterExtensions;

        if(this.Valuation){
            localStorage.setItem('parametry_valuation_'+this.produktPrefix, serialize(formTMP));
        } else {
            // var x = serialize("test");
            try {
                localStorage.setItem('parametry_'+this.produktPrefix, serialize(formTMP));
            } catch(e){
                
            }
             
        }
             
        // console.log("zapisuje parametry", this); 
      }
      public blobToBase64(blob) {
        return new Promise((resolve, _) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
      
      ZapiszParametryJSON(sanitizer) {
    
        // console.log("zapisuje parametry", this);
        var formTMP = new FormDataV2Save();

        formTMP.Parameters = this.GetAllParamsSave();
        formTMP.ParameterExtensions = [];
        if(this.ParameterExtensions == null){
            this.ParameterExtensions = [];
        }
        this.ParameterExtensions.forEach(par => {
            var p = new KimSave();
            p.Index = par.Index;
            p.Module = par.Module;
            p.Position = par.Position;
            p.Quantity = par.Quantity;
            formTMP.ParameterExtensions.push(p);
        }); 
        //formTMP.IsFooter = this.IsFooter;
        //formTMP.IsModule = this.IsModule;
        //formTMP.IsModuleFooter = this.IsModuleFooter;
       // formTMP.IsTrader = this.IsTrader;
       // formTMP.Order = this.Order;
       // console.log("order", this.Order, this);
        formTMP.OrderSave = new Order();
        formTMP.OrderSave.DeliveryMethodId = this.delivery.DeliveryMethod.Id;
        
        if(this.delivery.ChosenAdresses != null){
            formTMP.OrderSave.DeliveryAddressId = this.delivery.ChosenAdresses.Id;
        }
        
        const data = serialize(formTMP);
        const blob = new Blob([data], { type: 'application/octet-stream' });
    
        //this.fileUrl = sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

        var downloadURL = window.URL.createObjectURL(blob);
      
        // console.log(plik);
        // window.open(downloadURL,'_blank');
  
        var fileLink = document.createElement('a');
        fileLink.href = downloadURL;
        fileLink.target = "_blank"; 
        fileLink.download = "plik"+this.produktPrefix+".json";
        fileLink.click();
  

      }
      ZapiszParametryXML(sanitizer) {
    
        // console.log("zapisuje parametry", this);
        var formTMP = new FormDataV2Save();

        formTMP.Parameters = this.GetAllParamsSave();
        formTMP.ParameterExtensions = [];
        if(this.ParameterExtensions == null){
            this.ParameterExtensions = [];
        }
        this.ParameterExtensions.forEach(par => {
            var p = new KimSave();
            p.Index = par.Index;
            p.Module = par.Module;
            p.Position = par.Position;
            p.Quantity = par.Quantity;
            formTMP.ParameterExtensions.push(p);
        }); 
        
        //formTMP.IsFooter = this.IsFooter;
        //formTMP.IsModule = this.IsModule;
        //formTMP.IsModuleFooter = this.IsModuleFooter;
       // formTMP.IsTrader = this.IsTrader;
       // formTMP.Order = this.Order;
       // console.log("order2", this.Order, this);
        // formTMP.OrderSave = this.Order;
        formTMP.OrderSave = new Order();
        formTMP.OrderSave.DeliveryMethodId = this.delivery.DeliveryMethod.Id;
        if(this.delivery.ChosenAdresses != null){
            formTMP.OrderSave.DeliveryAddressId = this.delivery.ChosenAdresses.Id;
        }
        

        var js2xmlparser = require("js2xmlparser");
        const data = js2xmlparser.parse("order", formTMP);
        //const data = serialize(formTMP);
        // console.log("data", data);
        const blob = new Blob([data], { type: 'application/octet-stream' });
    
        //this.fileUrl = sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

        var downloadURL = window.URL.createObjectURL(blob);
      
        // console.log(plik);
        // window.open(downloadURL,'_blank');
  
        var fileLink = document.createElement('a');
        fileLink.href = downloadURL;
        fileLink.target = "_blank"; 
        fileLink.download = "plik"+this.produktPrefix+".xml";
        fileLink.click();
  

      }
      WczytajParametry(json = null):Parameter[]{
        var parametry:Parameter[] = [];
        try {
            if(json == null){
                if(this.Valuation){
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_valuation_'+this.produktPrefix));
                } else {
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_'+this.produktPrefix));
                }
                
            } else {
                var kr:FormDataV2 =  json;
            }
          
          
         // console.log("wczytane parametry1", kr);
         parametry = kr.Parameters;
         // this.Files = kr.Files;
          /*kr.kroki.forEach(k => {
            k.Controlls.forEach(con => {
                parametry.push(con.wybrany);
              });
           
          }); */
          kr.Order = new Order();
          
          try {
            kr.Order.DeliveryMethodId = kr.delivery.DeliveryMethod.Id;
          } catch (errr){

          }
          try {
            kr.Order.DeliveryAddressId = kr.delivery.ChosenAdresses.Id;
          } catch (errr){

          }
          
          this.Order = kr.Order;
          //this.ZapiszParametry();
         // console.log("wczytane parametry", parametry);
          
          
          return parametry;
        } catch(Exception){
            // this.ZapiszParametry();
          return parametry;
        }
        
      }
      WczytajExtParametry(json = null):Kim[]{
        var parametry:Kim[] = [];
        try {
            if(json == null){
                if(this.Valuation){
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_valuation_'+this.produktPrefix));
                } else {
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_'+this.produktPrefix));
                }
            } else {
                var kr:FormDataV2 =  json;
            }
          // console.log("kr", kr);
         parametry = kr.ParameterExtensions;
         
         // this.ZapiszParametry();
          return parametry;
        } catch(Exception){
            // this.ZapiszParametry();
          return parametry;
        }
        
      }
      WczytajOrder(json = null){
        // console.log("xxx");
        var Order;
        try {
            if(json == null){
                
                if(this.Valuation){
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_valuation_'+this.produktPrefix));
                } else {
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_'+this.produktPrefix));
                }
            } else {
                var kr:FormDataV2 =  json;
            }
            Order = kr.OrderSave;
         
          return Order;
        } catch(Exception){
            // console.log("error", Exception);
          return Order;
        }
      }
      WczytajPliki(json = null):FileControl[]{
        var pliki:FileControl[] = [];
        try {
            if(json == null){
                
                if(this.Valuation){
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_valuation_'+this.produktPrefix));
                } else {
                    var kr:FormDataV2 =  deserialize(FormDataV2,localStorage.getItem('parametry_'+this.produktPrefix));
                }
            } else {
                var kr:FormDataV2 =  json;
            }
          pliki = kr.Files;
         
          return pliki;
        } catch(Exception){
          return pliki;
        }
        
      }

  }
 


 

  


  